/* tslint:disable */
/* eslint-disable */
/**
 * Spits Customer Portal API
 * Spits Customer Portal API.
 *
 * The version of the OpenAPI document: v1
 * Contact: info@tres.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Activate account.
 * @export
 * @interface ActivateAccountRequest
 */
export interface ActivateAccountRequest {
    /**
     * Activation token.
     * @type {string}
     * @memberof ActivateAccountRequest
     */
    activationToken: string;
    /**
     * New password.
     * @type {string}
     * @memberof ActivateAccountRequest
     */
    password: string;
}
/**
 * 
 * @export
 * @interface AddPharmacistCommand
 */
export interface AddPharmacistCommand {
    /**
     * EmailAddress
     * @type {string}
     * @memberof AddPharmacistCommand
     */
    emailAddress: string;
    /**
     * FirstName
     * @type {string}
     * @memberof AddPharmacistCommand
     */
    firstName: string;
    /**
     * MiddleName
     * @type {string}
     * @memberof AddPharmacistCommand
     */
    middleName?: string | null;
    /**
     * LastName
     * @type {string}
     * @memberof AddPharmacistCommand
     */
    lastName: string;
    /**
     * Type of Pharmacist  can be:  Employee  or  Management
     * @type {PharmacistType}
     * @memberof AddPharmacistCommand
     */
    pharmacistType: PharmacistType;
}
/**
 * Command to add pharmacist to pharmacy.
 * @export
 * @interface AddPharmacistCommandAllOf
 */
export interface AddPharmacistCommandAllOf {
    /**
     * EmailAddress
     * @type {string}
     * @memberof AddPharmacistCommandAllOf
     */
    emailAddress: string;
    /**
     * FirstName
     * @type {string}
     * @memberof AddPharmacistCommandAllOf
     */
    firstName: string;
    /**
     * MiddleName
     * @type {string}
     * @memberof AddPharmacistCommandAllOf
     */
    middleName?: string | null;
    /**
     * LastName
     * @type {string}
     * @memberof AddPharmacistCommandAllOf
     */
    lastName: string;
    /**
     * Type of Pharmacist  can be:  Employee  or  Management
     * @type {PharmacistType}
     * @memberof AddPharmacistCommandAllOf
     */
    pharmacistType: PharmacistType;
}
/**
 * Add pharmacist.
 * @export
 * @interface AddPharmacistRequest
 */
export interface AddPharmacistRequest {
    /**
     * Email address.
     * @type {string}
     * @memberof AddPharmacistRequest
     */
    emailAddress: string;
    /**
     * First name.
     * @type {string}
     * @memberof AddPharmacistRequest
     */
    firstName: string;
    /**
     * Middle name.
     * @type {string}
     * @memberof AddPharmacistRequest
     */
    middleName?: string | null;
    /**
     * Last name.
     * @type {string}
     * @memberof AddPharmacistRequest
     */
    lastName: string;
    /**
     * Pharmacist type.
     * @type {PharmacistType}
     * @memberof AddPharmacistRequest
     */
    pharmacistType: PharmacistType;
}
/**
 * Add service product order.
 * @export
 * @interface AddServiceProductOrderRequest
 */
export interface AddServiceProductOrderRequest {
    /**
     * Ordered products.
     * @type {Array<AddServiceProductOrderRowRequest>}
     * @memberof AddServiceProductOrderRequest
     */
    orderRows: Array<AddServiceProductOrderRowRequest>;
}
/**
 * Add service product order row.
 * @export
 * @interface AddServiceProductOrderRowRequest
 */
export interface AddServiceProductOrderRowRequest {
    /**
     * Id of the service product.
     * @type {number}
     * @memberof AddServiceProductOrderRowRequest
     */
    serviceProductId: number;
    /**
     * Amount ordered.
     * @type {number}
     * @memberof AddServiceProductOrderRowRequest
     */
    amount: number;
}
/**
 * Additional information.
 * @export
 * @enum {string}
 */

export enum AdditionalInformation {
    PatientDataSeenAtAnotherPharmacy = 'PatientDataSeenAtAnotherPharmacy',
    CorrectContentIncorrectlyDeliveredContainer = 'CorrectContentIncorrectlyDeliveredContainer',
    IncorrectContentIncorrectlyDeliveredContainer = 'IncorrectContentIncorrectlyDeliveredContainer',
    CorrectLabelIncorrectlyDeliveredCrate = 'CorrectLabelIncorrectlyDeliveredCrate',
    IncorrectLabelIncorrectlyDeliveredContainer = 'IncorrectLabelIncorrectlyDeliveredContainer'
}

/**
 * 
 * @export
 * @interface AskNonFaqQuestionCommand
 */
export interface AskNonFaqQuestionCommand {
    /**
     * Question to ask which is not in the FAQ
     * @type {string}
     * @memberof AskNonFaqQuestionCommand
     */
    question: string;
}
/**
 * Ask a question, which is not in the FAQ
 * @export
 * @interface AskNonFaqQuestionCommandAllOf
 */
export interface AskNonFaqQuestionCommandAllOf {
    /**
     * Question to ask which is not in the FAQ
     * @type {string}
     * @memberof AskNonFaqQuestionCommandAllOf
     */
    question: string;
}
/**
 * Information returned after a successful login.
 * @export
 * @interface AuthorizedResultDto
 */
export interface AuthorizedResultDto {
    /**
     * The JWT token to authenicate future calls to the API.
     * @type {string}
     * @memberof AuthorizedResultDto
     */
    accessToken?: string | null;
    /**
     * The token to refresh an expired access token with.
     * @type {string}
     * @memberof AuthorizedResultDto
     */
    refreshToken?: string | null;
    /**
     * Minimal data-set of the logged in user.
     * @type {UserInfoDto}
     * @memberof AuthorizedResultDto
     */
    userInfo?: UserInfoDto | null;
}
/**
 * 
 * @export
 * @interface Command
 */
export interface Command {
}
/**
 * 
 * @export
 * @interface CommandOfInteger
 */
export interface CommandOfInteger {
}
/**
 * Complaint category.
 * @export
 * @enum {string}
 */

export enum ComplaintCategory {
    Delivery = 'Delivery',
    MedicationRoll = 'MedicationRoll',
    Medication = 'Medication',
    Assortment = 'Assortment',
    ServiceProducts = 'ServiceProducts',
    Other = 'Other'
}

/**
 * Complaint kinds
 * @export
 * @enum {string}
 */

export enum ComplaintKind {
    DocumentationNotReceived = 'DocumentationNotReceived',
    AssortmentChange = 'AssortmentChange',
    DepartmentNotDelivered = 'DepartmentNotDelivered',
    CrateNotDelivered = 'CrateNotDelivered',
    CrateIncorrectlyDelivered = 'CrateIncorrectlyDelivered',
    MedicationAtWrongTime = 'MedicationAtWrongTime',
    ReceivingTooLittleMedication = 'ReceivingTooLittleMedication',
    ReceivingTooMuchMedication = 'ReceivingTooMuchMedication',
    IncorrectDrugInRoll = 'IncorrectDrugInRoll',
    MedicationBagsAreMissing = 'MedicationBagsAreMissing',
    MedicationRolesTiedTogether = 'MedicationRolesTiedTogether',
    MedicationRollReceivedTooLittle = 'MedicationRollReceivedTooLittle',
    MedicationRollReceivedTooMuch = 'MedicationRollReceivedTooMuch',
    MedicationDamagedInBag = 'MedicationDamagedInBag',
    MedicationRollInWrongPackingService = 'MedicationRollInWrongPackingService',
    AdministrationListsNotSupplied = 'AdministrationListsNotSupplied',
    IncorrectAdministrationListsSupplied = 'IncorrectAdministrationListsSupplied',
    IncorrectAntiemeticSchedule = 'IncorrectAntiemeticSchedule',
    IncorrectAddressLabelPackaging = 'IncorrectAddressLabelPackaging',
    BadTearingBags = 'BadTearingBags',
    BadPrintBags = 'BadPrintBags',
    BagsDamaged = 'BagsDamaged',
    ErrorHandledIncorrectly = 'ErrorHandledIncorrectly',
    MedicationRollContainsEmptyBags = 'MedicationRollContainsEmptyBags',
    MedicationRollPackedInWrongBag = 'MedicationRollPackedInWrongBag'
}

/**
 * Disable totp.
 * @export
 * @interface DisableTotpRequest
 */
export interface DisableTotpRequest {
    /**
     * Current password.
     * @type {string}
     * @memberof DisableTotpRequest
     */
    currentPassword: string;
    /**
     * Current Totp pin.
     * @type {string}
     * @memberof DisableTotpRequest
     */
    pin: string;
}
/**
 * Discoverer of complaint
 * @export
 * @enum {string}
 */

export enum DiscovererComplaint {
    Pharmacy = 'Pharmacy',
    Patint = 'Patiënt',
    Nursery = 'Nursery',
    Other = 'Other'
}

/**
 * drop down data dto.
 * @export
 * @interface DropdownDataDto
 */
export interface DropdownDataDto {
    /**
     * Imperfection type.
     * @type {Array<DropdownDto>}
     * @memberof DropdownDataDto
     */
    imperfectionType?: Array<DropdownDto> | null;
    /**
     * Feedback message.
     * @type {Array<DropdownDto>}
     * @memberof DropdownDataDto
     */
    feedbackMessage?: Array<DropdownDto> | null;
    /**
     * ComplaintCategories.
     * @type {Array<DropdownDto>}
     * @memberof DropdownDataDto
     */
    complaintCategories?: Array<DropdownDto> | null;
    /**
     * Complaint kinds.
     * @type {{ [key: string]: Array<DropdownDto>; }}
     * @memberof DropdownDataDto
     */
    complaintKinds?: { [key: string]: Array<DropdownDto>; } | null;
    /**
     * Additional information.
     * @type {Array<DropdownDto>}
     * @memberof DropdownDataDto
     */
    additionalInformation?: Array<DropdownDto> | null;
    /**
     * Origin fault discovered.
     * @type {Array<DropdownDto>}
     * @memberof DropdownDataDto
     */
    originFaultDiscovered?: Array<DropdownDto> | null;
}
/**
 * Dropdown data dto
 * @export
 * @interface DropdownDataDto2
 */
export interface DropdownDataDto2 {
    /**
     * Discoverer complaint.
     * @type {Array<DropdownDto2>}
     * @memberof DropdownDataDto2
     */
    discovererComplaint?: Array<DropdownDto2> | null;
    /**
     * Nature complaint.
     * @type {Array<DropdownDto2>}
     * @memberof DropdownDataDto2
     */
    natureComplaint?: Array<DropdownDto2> | null;
    /**
     * Feedback message.
     * @type {Array<DropdownDto2>}
     * @memberof DropdownDataDto2
     */
    feedbackMessage?: Array<DropdownDto2> | null;
}
/**
 * Enum dto.
 * @export
 * @interface DropdownDto
 */
export interface DropdownDto {
    /**
     * Value.
     * @type {string}
     * @memberof DropdownDto
     */
    value?: string | null;
    /**
     * Description
     * @type {string}
     * @memberof DropdownDto
     */
    text?: string | null;
}
/**
 * Dropdown dto.
 * @export
 * @interface DropdownDto2
 */
export interface DropdownDto2 {
    /**
     * Value.
     * @type {string}
     * @memberof DropdownDto2
     */
    value?: string | null;
    /**
     * Description
     * @type {string}
     * @memberof DropdownDto2
     */
    text?: string | null;
}
/**
 * 
 * @export
 * @interface DrugTableDto
 */
export interface DrugTableDto {
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    ziNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    longName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    prk?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    dtaDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    splitDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    hpk?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    gpk?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    packaging?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrugTableDto
     */
    manufacturer?: string | null;
}
/**
 * Enable totp.
 * @export
 * @interface EnableTotpRequest
 */
export interface EnableTotpRequest {
    /**
     * Current password.
     * @type {string}
     * @memberof EnableTotpRequest
     */
    currentPassword: string;
    /**
     * Current Totp pin.
     * @type {string}
     * @memberof EnableTotpRequest
     */
    verificationPin: string;
}
/**
 * 
 * @export
 * @interface ExportAssortmentToExcelQuery
 */
export interface ExportAssortmentToExcelQuery {
}
/**
 * 
 * @export
 * @interface FaqItemDto
 */
export interface FaqItemDto {
    /**
     * 
     * @type {string}
     * @memberof FaqItemDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaqItemDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaqItemDto
     */
    content?: string | null;
}
/**
 * Ways to receive feedback.
 * @export
 * @enum {string}
 */

export enum FeedBackOption {
    Phone = 'Phone',
    Email = 'Email'
}

/**
 * Feedback message.
 * @export
 * @enum {string}
 */

export enum FeedbackMessage {
    Mail = 'Mail',
    Telephone = 'Telephone',
    NoFeedbackNecessary = 'NoFeedbackNecessary'
}

/**
 * Feedback message.
 * @export
 * @enum {string}
 */

export enum FeedbackMessage2 {
    Mail = 'Mail',
    Telephone = 'Telephone',
    NoFeedbackNecessary = 'NoFeedbackNecessary'
}

/**
 * Gender Enum  Options: Male and Female
 * @export
 * @enum {string}
 */

export enum Gender {
    Male = 'Male',
    Female = 'Female'
}

/**
 * Response of the request for a file with an id. Containing the path of the actual file, and the description added to the file
 * @export
 * @interface GetFileResponse
 */
export interface GetFileResponse {
    /**
     * A short description added by uploader to the file
     * @type {string}
     * @memberof GetFileResponse
     */
    shortDescription?: string | null;
    /**
     * Path of the file on the server
     * @type {string}
     * @memberof GetFileResponse
     */
    path?: string | null;
}
/**
 * Details of the user who posts a form
 * @export
 * @interface GetFormPostUserDetailsDto
 */
export interface GetFormPostUserDetailsDto {
    /**
     * Name of the pharmacy belonging to the pharmacist
     * @type {string}
     * @memberof GetFormPostUserDetailsDto
     */
    pharmacyName?: string | null;
    /**
     * Name of the pharmacist
     * @type {string}
     * @memberof GetFormPostUserDetailsDto
     */
    pharmacistName?: string | null;
    /**
     * Emailaddress of the pharmacist
     * @type {string}
     * @memberof GetFormPostUserDetailsDto
     */
    emailAddress?: string | null;
}
/**
 * ImperfectionAbout
 * @export
 * @enum {string}
 */

export enum ImperfectionAbout {
    Packaging = 'Packaging',
    Drugs = 'Drugs',
    Crate = 'Crate',
    Scroll = 'Scroll',
    Bag = 'Bag',
    Tdl = 'Tdl',
    AddressLabel = 'AddressLabel',
    Unknown = 'Unknown'
}

/**
 * Imperfection impact.
 * @export
 * @enum {string}
 */

export enum ImperfectionImpact {
    UsedNoDamage = 'UsedNoDamage',
    UsedDamage = 'UsedDamage',
    NotUsedDamage = 'NotUsedDamage',
    NotUsedNoDamage = 'NotUsedNoDamage',
    UnknownNoDamage = 'UnknownNoDamage'
}

/**
 * Imperfection inception dto.
 * @export
 * @interface ImperfectionInceptionDto
 */
export interface ImperfectionInceptionDto {
    /**
     * Patient id.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    patientId?: string | null;
    /**
     * Date time on the bag.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    dateTimeBag?: string | null;
    /**
     * Feedback message.
     * @type {FeedbackMessage}
     * @memberof ImperfectionInceptionDto
     */
    feedbackMessage: FeedbackMessage;
    /**
     * Contact person.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    contactPerson?: string | null;
    /**
     * Mail address.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    emailAddress?: string | null;
    /**
     * Phone number.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    phoneNumber?: string | null;
    /**
     * Is complaint.
     * @type {boolean}
     * @memberof ImperfectionInceptionDto
     */
    isComplaint?: boolean;
    /**
     * Remarks.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    remarks?: string | null;
    /**
     * Complaint category.
     * @type {ComplaintCategory}
     * @memberof ImperfectionInceptionDto
     */
    complaintCategory?: ComplaintCategory | null;
    /**
     * Complaint kind.
     * @type {ComplaintKind}
     * @memberof ImperfectionInceptionDto
     */
    complaintKind?: ComplaintKind | null;
    /**
     * Additional information.
     * @type {Array<AdditionalInformation>}
     * @memberof ImperfectionInceptionDto
     */
    additionalInformation?: Array<AdditionalInformation> | null;
    /**
     * From which pharmacy.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    fromPharmacy?: string | null;
    /**
     * From which department.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    fromDepartment?: string | null;
    /**
     * Crate amount.
     * @type {number}
     * @memberof ImperfectionInceptionDto
     */
    crateAmount?: number;
    /**
     * Additional information.
     * @type {OriginFaultDiscovered}
     * @memberof ImperfectionInceptionDto
     */
    originFaultDiscovered?: OriginFaultDiscovered | null;
    /**
     * Description other.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    descriptionOther?: string | null;
    /**
     * Taken actions.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    takenActions?: string | null;
    /**
     * Explanation question.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    explanationQuestion?: string | null;
    /**
     * Optional image.
     * @type {string}
     * @memberof ImperfectionInceptionDto
     */
    imageGuid?: string | null;
}
/**
 * Imperfection inception dto.
 * @export
 * @interface ImperfectionInceptionDto2
 */
export interface ImperfectionInceptionDto2 {
    /**
     * Pharmacy contact person.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    pharmacyContactPerson: string;
    /**
     * Discoverer complaint.
     * @type {DiscovererComplaint}
     * @memberof ImperfectionInceptionDto2
     */
    discovererComplaint?: DiscovererComplaint;
    /**
     * Nature complaint
     * @type {NatureComplaint}
     * @memberof ImperfectionInceptionDto2
     */
    natureComplaint?: NatureComplaint;
    /**
     * Other
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    other?: string | null;
    /**
     * Optional image.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    imageGuid?: string | null;
    /**
     * Medicine.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    medicine?: string | null;
    /**
     * Department.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    department: string;
    /**
     * Patient id.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    patientId?: string | null;
    /**
     * Start swallow date.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    startSwallowDate: string;
    /**
     * Scroll end date.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    scrollEndDate: string;
    /**
     * Intake date.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    intakeDate?: string | null;
    /**
     * Feedback message
     * @type {FeedbackMessage2}
     * @memberof ImperfectionInceptionDto2
     */
    feedbackMessage: FeedbackMessage2;
    /**
     * Phone number.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    feedbackPhoneNumber?: string | null;
    /**
     * Email address.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    feedbackEmailAddress?: string | null;
    /**
     * Intake time.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    intakeTime?: string | null;
    /**
     * Detailed description message.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    detailedDescriptionMessage?: string | null;
    /**
     * Actions taken immediately.
     * @type {string}
     * @memberof ImperfectionInceptionDto2
     */
    actionsTakenImmediately?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ImperfectionLocation {
    Pharmacy = 'Pharmacy',
    Institution = 'Institution',
    Patient = 'Patient'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ImperfectionType {
    MissingDrug = 'MissingDrug',
    MissingBag = 'MissingBag',
    MissingScroll = 'MissingScroll',
    MissingTdl = 'MissingTdl',
    MissingAddress = 'MissingAddress',
    WrongDrugs = 'WrongDrugs',
    WrongScroll = 'WrongScroll',
    WrongCrate = 'WrongCrate',
    WrongTdl = 'WrongTdl',
    WrongAddress = 'WrongAddress',
    WrongPackaging = 'WrongPackaging',
    TooManyDrugs = 'TooManyDrugs',
    TooManyScrolls = 'TooManyScrolls',
    DamagedDrugs = 'DamagedDrugs',
    DamagedBag = 'DamagedBag',
    DamagedScroll = 'DamagedScroll',
    DamagedPackaging = 'DamagedPackaging',
    Late = 'Late',
    Missing = 'Missing'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ImperfectionTypeInception {
    MissingAddressLabel = 'MissingAddressLabel',
    BadPrintAddressLabel = 'BadPrintAddressLabel',
    WrongAddressLabel = 'WrongAddressLabel',
    ReceivedCrateLate = 'ReceivedCrateLate',
    NotReceivedCrates = 'NotReceivedCrates',
    WrongCrate = 'WrongCrate',
    WrongDrugs = 'WrongDrugs',
    ScrollWithIncorrectDate = 'ScrollWithIncorrectDate',
    ScrollAttachedToAnotherScroll = 'ScrollAttachedToAnotherScroll',
    BadPerforationScroll = 'BadPerforationScroll',
    MissingScroll = 'MissingScroll',
    BadPrintScroll = 'BadPrintScroll',
    ToManyScrolls = 'ToManyScrolls',
    WrongScroll = 'WrongScroll',
    MissingTdl = 'MissingTdl',
    BadPrintTdl = 'BadPrintTdl',
    ToManyTdl = 'ToManyTdl',
    WrongPackaging = 'WrongPackaging',
    WrongPackaging = 'WrongPackaging',
    DamagedPackaging = 'DamagedPackaging',
    MissingBag = 'MissingBag',
    BadPerforationBag = 'BadPerforationBag',
    BadPringBag = 'BadPringBag',
    BagNotClosedProperly = 'BagNotClosedProperly',
    DescribeAtAdditionalInfo = 'DescribeAtAdditionalInfo',
    MissingAddressLabelData = 'MissingAddressLabelData',
    BadSealScroll = 'BadSealScroll',
    ReceivedCrateAtWrongLocation = 'ReceivedCrateAtWrongLocation',
    DamagedDrugs = 'DamagedDrugs',
    IncompleteTdl = 'IncompleteTdl',
    WrongAmount = 'WrongAmount'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum InvoiceFileType {
    Pdf = 'Pdf',
    PdfDetails = 'PdfDetails',
    Excel = 'Excel',
    ExcelDetails = 'ExcelDetails'
}

/**
 * Dto for datatable view of invoices.
 * @export
 * @interface InvoiceTableDto
 */
export interface InvoiceTableDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceTableDto
     */
    clientCode?: string | null;
    /**
     * Month of processing the invoice
     * @type {string}
     * @memberof InvoiceTableDto
     */
    processedMonth?: string | null;
    /**
     * Currency amount of the invoice
     * @type {number}
     * @memberof InvoiceTableDto
     */
    invoiceAmount?: number;
    /**
     * Filetypes which are allowed access to
     * @type {Array<InvoiceFileType>}
     * @memberof InvoiceTableDto
     */
    validFileTypes?: Array<InvoiceFileType> | null;
}
/**
 * Is activation token valid.
 * @export
 * @interface IsActivationTokenValidRequest
 */
export interface IsActivationTokenValidRequest {
    /**
     * Activation token.
     * @type {string}
     * @memberof IsActivationTokenValidRequest
     */
    activationToken?: string | null;
}
/**
 * Is password reset token valid.
 * @export
 * @interface IsPasswordResetTokenValidRequest
 */
export interface IsPasswordResetTokenValidRequest {
    /**
     * Token.
     * @type {string}
     * @memberof IsPasswordResetTokenValidRequest
     */
    passwordResetToken: string;
}
/**
 * Login to an account with credentials.
 * @export
 * @interface LoginWithCredentialsRequest
 */
export interface LoginWithCredentialsRequest {
    /**
     * Email address of the account.
     * @type {string}
     * @memberof LoginWithCredentialsRequest
     */
    emailAddress: string;
    /**
     * Password of the account.
     * @type {string}
     * @memberof LoginWithCredentialsRequest
     */
    password: string;
}
/**
 * 
 * @export
 * @interface LoginWithTotpRequest
 */
export interface LoginWithTotpRequest {
    /**
     * Email address of the account.
     * @type {string}
     * @memberof LoginWithTotpRequest
     */
    emailAddress: string;
    /**
     * Password of the account.
     * @type {string}
     * @memberof LoginWithTotpRequest
     */
    password: string;
    /**
     * The current Totp pin of the account.
     * @type {string}
     * @memberof LoginWithTotpRequest
     */
    pin: string;
}
/**
 * Login to an account with credentials and Totp.
 * @export
 * @interface LoginWithTotpRequestAllOf
 */
export interface LoginWithTotpRequestAllOf {
    /**
     * The current Totp pin of the account.
     * @type {string}
     * @memberof LoginWithTotpRequestAllOf
     */
    pin: string;
}
/**
 * 
 * @export
 * @interface MemoDto
 */
export interface MemoDto {
    /**
     * 
     * @type {number}
     * @memberof MemoDto
     */
    memoId?: number;
    /**
     * 
     * @type {string}
     * @memberof MemoDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoDto
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoDto
     */
    createDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MemoDto
     */
    updateDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoDto
     */
    authorName?: string | null;
    /**
     * 
     * @type {MemoType}
     * @memberof MemoDto
     */
    memoType?: MemoType;
}
/**
 * Type of memo
 * @export
 * @enum {string}
 */

export enum MemoType {
    Standard = 'Standard'
}

/**
 * Nature complaint
 * @export
 * @enum {string}
 */

export enum NatureComplaint {
    MissingMedication = 'MissingMedication',
    MissingBag = 'MissingBag',
    MissingRolls = 'MissingRolls',
    MissingAdministrationList = 'MissingAdministrationList',
    MissingAddressLabels = 'MissingAddressLabels',
    WrongPackaging = 'WrongPackaging',
    WrongMedication = 'WrongMedication',
    WrongRoll = 'WrongRoll',
    WrongDelivered = 'WrongDelivered',
    WrongAdministrationList = 'WrongAdministrationList',
    WrongAddressLabel = 'WrongAddressLabel',
    TooMuchMedication = 'TooMuchMedication',
    TooMuchRolls = 'TooMuchRolls',
    DamagedMedication = 'DamagedMedication',
    DamagedBag = 'DamagedBag',
    DamagedRolls = 'DamagedRolls',
    DamagedPackaging = 'DamagedPackaging',
    TooLate = 'TooLate',
    NotReceived = 'NotReceived',
    Other = 'Other',
    TrayError = 'TrayError',
    PackedInWrongDepartment = 'PackedInWrongDepartment',
    MissingDepartment = 'MissingDepartment',
    InternalMistake = 'InternalMistake',
    PackedInWrongCrate = 'PackedInWrongCrate',
    RequestPhoto = 'RequestPhoto'
}

/**
 * Object holding the values needed for a new customer.
 * @export
 * @interface NewCustomerRequest
 */
export interface NewCustomerRequest {
    /**
     * Initials
     * @type {string}
     * @memberof NewCustomerRequest
     */
    initials: string;
    /**
     * MiddleName
     * @type {string}
     * @memberof NewCustomerRequest
     */
    middleName?: string | null;
    /**
     * LastName
     * @type {string}
     * @memberof NewCustomerRequest
     */
    lastName: string;
    /**
     * Date of birth
     * @type {string}
     * @memberof NewCustomerRequest
     */
    birthDate: string;
    /**
     * Gender
     * @type {Gender}
     * @memberof NewCustomerRequest
     */
    gender: Gender;
    /**
     * Optional  Patient number in case it is known by pharmacy but not by the system/database.
     * @type {number}
     * @memberof NewCustomerRequest
     */
    patientNumber?: number | null;
}
/**
 * 
 * @export
 * @interface OrderFulfillmentScheduleDto
 */
export interface OrderFulfillmentScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    pharmacy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    pharmacyClient?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    facility?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    facilityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    arrivalTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    arrivalDay?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    shipmentTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentScheduleDto
     */
    shipmentDay?: string | null;
}
/**
 * 
 * @export
 * @interface OrderFulfillmentTableDto
 */
export interface OrderFulfillmentTableDto {
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentTableDto
     */
    orderDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentTableDto
     */
    client?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentTableDto
     */
    clientCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentTableDto
     */
    facility?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderFulfillmentTableDto
     */
    bagCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderFulfillmentTableDto
     */
    patientCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderFulfillmentTableDto
     */
    errorPatients?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderFulfillmentTableDto
     */
    warningPatients?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrderFulfillmentTableDto
     */
    productionOrder?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrderFulfillmentTableDto
     */
    importOk?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderFulfillmentTableDto
     */
    deleted?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrderFulfillmentTableDto
     */
    correctionOrder?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OrderFulfillmentTableDto
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderFulfillmentTableDto
     */
    reel?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderFulfillmentTableDto
     */
    reelStatus?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderFulfillmentTableDto
     */
    reelStatusText?: string | null;
}
/**
 * Origin fault discovered
 * @export
 * @enum {string}
 */

export enum OriginFaultDiscovered {
    Pharmacy = 'Pharmacy',
    Patient = 'Patient',
    Nursing = 'Nursing'
}

/**
 * 
 * @export
 * @interface PatientDto
 */
export interface PatientDto {
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    patientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    patientName?: string | null;
    /**
     * 
     * @type {Gender}
     * @memberof PatientDto
     */
    gender?: Gender;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    birthDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    facility?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatientDto
     */
    clientCode?: string | null;
}
/**
 * 
 * @export
 * @interface PharmacistDto
 */
export interface PharmacistDto {
    /**
     * 
     * @type {number}
     * @memberof PharmacistDto
     */
    accountId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PharmacistDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PharmacistDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PharmacistDto
     */
    pharmacyId?: number;
    /**
     * 
     * @type {string}
     * @memberof PharmacistDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PharmacistDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PharmacistDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {PharmacistType}
     * @memberof PharmacistDto
     */
    pharmacistType?: PharmacistType;
}
/**
 * 
 * @export
 * @interface PharmacistTableDto
 */
export interface PharmacistTableDto {
    /**
     * 
     * @type {number}
     * @memberof PharmacistTableDto
     */
    accountId?: number;
    /**
     * 
     * @type {string}
     * @memberof PharmacistTableDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PharmacistTableDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PharmacistTableDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PharmacistTableDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {PharmacistType}
     * @memberof PharmacistTableDto
     */
    pharmacistType?: PharmacistType;
    /**
     * 
     * @type {boolean}
     * @memberof PharmacistTableDto
     */
    isActive?: boolean;
}
/**
 * Dto for PharmacistTable
 * @export
 * @interface PharmacistTableDto2
 */
export interface PharmacistTableDto2 {
    /**
     * AccountId.
     * @type {number}
     * @memberof PharmacistTableDto2
     */
    accountId?: number;
    /**
     * E-mailaddress of account
     * @type {string}
     * @memberof PharmacistTableDto2
     */
    emailAddress?: string | null;
    /**
     * First name
     * @type {string}
     * @memberof PharmacistTableDto2
     */
    firstName?: string | null;
    /**
     * Middle name
     * @type {string}
     * @memberof PharmacistTableDto2
     */
    middleName?: string | null;
    /**
     * Last name
     * @type {string}
     * @memberof PharmacistTableDto2
     */
    lastName?: string | null;
    /**
     * If the account is disabled.
     * @type {boolean}
     * @memberof PharmacistTableDto2
     */
    isDisabled?: boolean;
    /**
     * Type of pharmacist
     * @type {PharmacistType}
     * @memberof PharmacistTableDto2
     */
    pharmacistType?: PharmacistType;
}
/**
 * Roles within the customer portal  mijn- / portalomgeving.
 * @export
 * @enum {string}
 */

export enum PharmacistType {
    Management = 'Management',
    Employee = 'Employee',
    Administrator = 'Administrator'
}

/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any | any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    instance?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProblemDetails
     */
    extensions?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface QueryOfByteOf
 */
export interface QueryOfByteOf {
}
/**
 * 
 * @export
 * @interface QueryOfIEnumerableOfPatientDto
 */
export interface QueryOfIEnumerableOfPatientDto {
}
/**
 * Refresh the access token.
 * @export
 * @interface RefreshAccessTokenRequest
 */
export interface RefreshAccessTokenRequest {
    /**
     * The current JWT token to authenicate calls to the API.
     * @type {string}
     * @memberof RefreshAccessTokenRequest
     */
    accessToken: string;
    /**
     * The token to refresh an expired access token with.
     * @type {string}
     * @memberof RefreshAccessTokenRequest
     */
    refreshToken: string;
}
/**
 * 
 * @export
 * @interface ReportImperfectionCommand
 */
export interface ReportImperfectionCommand {
    /**
     * 
     * @type {ImperfectionLocation}
     * @memberof ReportImperfectionCommand
     */
    imperfectionLocation: ImperfectionLocation;
    /**
     * 
     * @type {ImperfectionType}
     * @memberof ReportImperfectionCommand
     */
    imperfectionType: ImperfectionType;
    /**
     * Optional image.
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    imageGuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    patientId: string;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    swallowDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    additionalInformation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    department?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    drugName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    drugStrength?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportImperfectionCommand
     */
    drugAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    generalAdditionalInformation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    takenActions?: string | null;
    /**
     * Ways to receive feedback. Phone or Email
     * @type {FeedBackOption}
     * @memberof ReportImperfectionCommand
     */
    feedBackOption?: FeedBackOption;
    /**
     * Contactdetails; Phone number or Emailaddress Based on FeedBackOption
     * @type {string}
     * @memberof ReportImperfectionCommand
     */
    contactInfo?: string | null;
}
/**
 * 
 * @export
 * @interface ReportImperfectionCommandAllOf
 */
export interface ReportImperfectionCommandAllOf {
    /**
     * 
     * @type {ImperfectionLocation}
     * @memberof ReportImperfectionCommandAllOf
     */
    imperfectionLocation: ImperfectionLocation;
    /**
     * 
     * @type {ImperfectionType}
     * @memberof ReportImperfectionCommandAllOf
     */
    imperfectionType: ImperfectionType;
    /**
     * Optional image.
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    imageGuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    patientId: string;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    swallowDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    additionalInformation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    department?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    drugName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    drugStrength?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportImperfectionCommandAllOf
     */
    drugAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    generalAdditionalInformation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    takenActions?: string | null;
    /**
     * Ways to receive feedback. Phone or Email
     * @type {FeedBackOption}
     * @memberof ReportImperfectionCommandAllOf
     */
    feedBackOption?: FeedBackOption;
    /**
     * Contactdetails; Phone number or Emailaddress Based on FeedBackOption
     * @type {string}
     * @memberof ReportImperfectionCommandAllOf
     */
    contactInfo?: string | null;
}
/**
 * 
 * @export
 * @interface ReportImperfectionInceptionCommand
 */
export interface ReportImperfectionInceptionCommand {
    /**
     * Imperfection location.
     * @type {ImperfectionLocation}
     * @memberof ReportImperfectionInceptionCommand
     */
    imperfectionLocation: ImperfectionLocation;
    /**
     * Imperfection about.
     * @type {ImperfectionAbout}
     * @memberof ReportImperfectionInceptionCommand
     */
    imperfectionAbout: ImperfectionAbout;
    /**
     * Imperfection type
     * @type {ImperfectionTypeInception}
     * @memberof ReportImperfectionInceptionCommand
     */
    imperfectionTypeInception: ImperfectionTypeInception;
    /**
     * Imperfection impact.
     * @type {ImperfectionImpact}
     * @memberof ReportImperfectionInceptionCommand
     */
    imperfectionImpact: ImperfectionImpact;
    /**
     * Optional image.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    imageGuid?: string | null;
    /**
     * Optional. Image extension.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    imageExtension?: string | null;
    /**
     * Optional. Image extension.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    imageFileType?: string | null;
    /**
     * Patient id.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    patientId?: string | null;
    /**
     * Swallow date.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    swallowDate?: string | null;
    /**
     * Drug name and strength.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    drugNameAndStrength?: string | null;
    /**
     * Batch number.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    batchNumber?: string | null;
    /**
     * Bag number.
     * @type {number}
     * @memberof ReportImperfectionInceptionCommand
     */
    bagNumber?: number | null;
    /**
     * Additional information.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    additionalInformation?: string | null;
    /**
     * Department.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    department?: string | null;
    /**
     * General additional information.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    generalAdditionalInformation?: string | null;
    /**
     * Taken actions.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommand
     */
    takenActions?: string | null;
}
/**
 * Command to report imperfection to inception
 * @export
 * @interface ReportImperfectionInceptionCommandAllOf
 */
export interface ReportImperfectionInceptionCommandAllOf {
    /**
     * Imperfection location.
     * @type {ImperfectionLocation}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    imperfectionLocation: ImperfectionLocation;
    /**
     * Imperfection about.
     * @type {ImperfectionAbout}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    imperfectionAbout: ImperfectionAbout;
    /**
     * Imperfection type
     * @type {ImperfectionTypeInception}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    imperfectionTypeInception: ImperfectionTypeInception;
    /**
     * Imperfection impact.
     * @type {ImperfectionImpact}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    imperfectionImpact: ImperfectionImpact;
    /**
     * Optional image.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    imageGuid?: string | null;
    /**
     * Optional. Image extension.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    imageExtension?: string | null;
    /**
     * Optional. Image extension.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    imageFileType?: string | null;
    /**
     * Patient id.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    patientId?: string | null;
    /**
     * Swallow date.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    swallowDate?: string | null;
    /**
     * Drug name and strength.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    drugNameAndStrength?: string | null;
    /**
     * Batch number.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    batchNumber?: string | null;
    /**
     * Bag number.
     * @type {number}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    bagNumber?: number | null;
    /**
     * Additional information.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    additionalInformation?: string | null;
    /**
     * Department.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    department?: string | null;
    /**
     * General additional information.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    generalAdditionalInformation?: string | null;
    /**
     * Taken actions.
     * @type {string}
     * @memberof ReportImperfectionInceptionCommandAllOf
     */
    takenActions?: string | null;
}
/**
 * 
 * @export
 * @interface RequestImmediateProductCommand
 */
export interface RequestImmediateProductCommand {
    /**
     * PatientId
     * @type {string}
     * @memberof RequestImmediateProductCommand
     */
    patientId?: string | null;
    /**
     * ExtraScrollIsHolidayScroll
     * @type {boolean}
     * @memberof RequestImmediateProductCommand
     */
    extraScrollIsHolidayScroll: boolean;
    /**
     * StartDate
     * @type {string}
     * @memberof RequestImmediateProductCommand
     */
    startDate: string;
    /**
     * AmountOfDays
     * @type {number}
     * @memberof RequestImmediateProductCommand
     */
    amountOfDays: number;
    /**
     * SendDate
     * @type {string}
     * @memberof RequestImmediateProductCommand
     */
    sendDate: string;
    /**
     * ReceiveDate
     * @type {string}
     * @memberof RequestImmediateProductCommand
     */
    receiveDate: string;
    /**
     * Optional attachment
     * @type {string}
     * @memberof RequestImmediateProductCommand
     */
    fileGuid?: string | null;
    /**
     * ReceiveReturnCall
     * @type {boolean}
     * @memberof RequestImmediateProductCommand
     */
    receiveReturnCall: boolean;
    /**
     * Optional  New customer
     * @type {NewCustomerRequest}
     * @memberof RequestImmediateProductCommand
     */
    newCustomer?: NewCustomerRequest | null;
}
/**
 * Command to request an Immediate product. (Aanvraag Rollen)
 * @export
 * @interface RequestImmediateProductCommandAllOf
 */
export interface RequestImmediateProductCommandAllOf {
    /**
     * PatientId
     * @type {string}
     * @memberof RequestImmediateProductCommandAllOf
     */
    patientId?: string | null;
    /**
     * ExtraScrollIsHolidayScroll
     * @type {boolean}
     * @memberof RequestImmediateProductCommandAllOf
     */
    extraScrollIsHolidayScroll: boolean;
    /**
     * StartDate
     * @type {string}
     * @memberof RequestImmediateProductCommandAllOf
     */
    startDate: string;
    /**
     * AmountOfDays
     * @type {number}
     * @memberof RequestImmediateProductCommandAllOf
     */
    amountOfDays: number;
    /**
     * SendDate
     * @type {string}
     * @memberof RequestImmediateProductCommandAllOf
     */
    sendDate: string;
    /**
     * ReceiveDate
     * @type {string}
     * @memberof RequestImmediateProductCommandAllOf
     */
    receiveDate: string;
    /**
     * Optional attachment
     * @type {string}
     * @memberof RequestImmediateProductCommandAllOf
     */
    fileGuid?: string | null;
    /**
     * ReceiveReturnCall
     * @type {boolean}
     * @memberof RequestImmediateProductCommandAllOf
     */
    receiveReturnCall: boolean;
    /**
     * Optional  New customer
     * @type {NewCustomerRequest}
     * @memberof RequestImmediateProductCommandAllOf
     */
    newCustomer?: NewCustomerRequest | null;
}
/**
 * 
 * @export
 * @interface RequestNewDepartmentCommand
 */
export interface RequestNewDepartmentCommand {
    /**
     * Name.
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    name: string;
    /**
     * Replaces other department.
     * @type {boolean}
     * @memberof RequestNewDepartmentCommand
     */
    replacesOtherDepartment: boolean;
    /**
     * Other department name
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    otherDepartmentName?: string | null;
    /**
     * Facturation
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    facturation?: string | null;
    /**
     * Patient amount.
     * @type {number}
     * @memberof RequestNewDepartmentCommand
     */
    patientAmount: number;
    /**
     * Scroll weeks.
     * @type {ScrollWeeks}
     * @memberof RequestNewDepartmentCommand
     */
    scrollWeeks: ScrollWeeks;
    /**
     * Amount of weeks when Other has been chosen.
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    amountWeeksOther?: string | null;
    /**
     * Scroll type.
     * @type {ScrollType}
     * @memberof RequestNewDepartmentCommand
     */
    scrollType: ScrollType;
    /**
     * Packaging service
     * @type {boolean}
     * @memberof RequestNewDepartmentCommand
     */
    packagingService: boolean;
    /**
     * Packaging type
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    packagingType?: string | null;
    /**
     * Administration lists.
     * @type {boolean}
     * @memberof RequestNewDepartmentCommand
     */
    administrationLists?: boolean | null;
    /**
     * Pharmacy delivery.
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    pharmacyDeliveryDay: string;
    /**
     * First delivery date.
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    desiredFirstDeliveryDate?: string | null;
    /**
     * First swallow date.
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    firstSwallowDate?: string | null;
    /**
     * First swallow time.
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    firstSwallowTime?: string | null;
    /**
     * Remarks.
     * @type {string}
     * @memberof RequestNewDepartmentCommand
     */
    remarks?: string | null;
}
/**
 * Request new department.
 * @export
 * @interface RequestNewDepartmentCommandAllOf
 */
export interface RequestNewDepartmentCommandAllOf {
    /**
     * Name.
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    name: string;
    /**
     * Replaces other department.
     * @type {boolean}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    replacesOtherDepartment: boolean;
    /**
     * Other department name
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    otherDepartmentName?: string | null;
    /**
     * Facturation
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    facturation?: string | null;
    /**
     * Patient amount.
     * @type {number}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    patientAmount: number;
    /**
     * Scroll weeks.
     * @type {ScrollWeeks}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    scrollWeeks: ScrollWeeks;
    /**
     * Amount of weeks when Other has been chosen.
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    amountWeeksOther?: string | null;
    /**
     * Scroll type.
     * @type {ScrollType}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    scrollType: ScrollType;
    /**
     * Packaging service
     * @type {boolean}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    packagingService: boolean;
    /**
     * Packaging type
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    packagingType?: string | null;
    /**
     * Administration lists.
     * @type {boolean}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    administrationLists?: boolean | null;
    /**
     * Pharmacy delivery.
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    pharmacyDeliveryDay: string;
    /**
     * First delivery date.
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    desiredFirstDeliveryDate?: string | null;
    /**
     * First swallow date.
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    firstSwallowDate?: string | null;
    /**
     * First swallow time.
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    firstSwallowTime?: string | null;
    /**
     * Remarks.
     * @type {string}
     * @memberof RequestNewDepartmentCommandAllOf
     */
    remarks?: string | null;
}
/**
 * 
 * @export
 * @interface RequestNewProductCommand
 */
export interface RequestNewProductCommand {
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommand
     */
    drugName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommand
     */
    drugStrength: string;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommand
     */
    consumptionPerWeek: string;
    /**
     * 
     * @type {number}
     * @memberof RequestNewProductCommand
     */
    amountOfPatients: number;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommand
     */
    ziNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommand
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface RequestNewProductCommandAllOf
 */
export interface RequestNewProductCommandAllOf {
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommandAllOf
     */
    drugName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommandAllOf
     */
    drugStrength: string;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommandAllOf
     */
    consumptionPerWeek: string;
    /**
     * 
     * @type {number}
     * @memberof RequestNewProductCommandAllOf
     */
    amountOfPatients: number;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommandAllOf
     */
    ziNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestNewProductCommandAllOf
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface RequestOfflineAssortmentCommand
 */
export interface RequestOfflineAssortmentCommand {
    /**
     * MedicationSet (Kuur medicatiesets)
     * @type {boolean}
     * @memberof RequestOfflineAssortmentCommand
     */
    medicationSet: boolean;
}
/**
 * Request for \"Kuur medicatiesets\"
 * @export
 * @interface RequestOfflineAssortmentCommandAllOf
 */
export interface RequestOfflineAssortmentCommandAllOf {
    /**
     * MedicationSet (Kuur medicatiesets)
     * @type {boolean}
     * @memberof RequestOfflineAssortmentCommandAllOf
     */
    medicationSet: boolean;
}
/**
 * Request password reset token.
 * @export
 * @interface RequestPasswordResetTokenRequest
 */
export interface RequestPasswordResetTokenRequest {
    /**
     * Email address of the account.
     * @type {string}
     * @memberof RequestPasswordResetTokenRequest
     */
    emailAddress: string;
}
/**
 * 
 * @export
 * @interface RequestPhotoCommand
 */
export interface RequestPhotoCommand {
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommand
     */
    patientId: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommand
     */
    patientBirthdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommand
     */
    swallowDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommand
     */
    drugName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommand
     */
    reasonOfRequest: string;
}
/**
 * 
 * @export
 * @interface RequestPhotoCommandAllOf
 */
export interface RequestPhotoCommandAllOf {
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommandAllOf
     */
    patientId: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommandAllOf
     */
    patientBirthdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommandAllOf
     */
    swallowDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommandAllOf
     */
    drugName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoCommandAllOf
     */
    reasonOfRequest: string;
}
/**
 * 
 * @export
 * @interface RequestStopDepartmentCommand
 */
export interface RequestStopDepartmentCommand {
    /**
     * Department.
     * @type {string}
     * @memberof RequestStopDepartmentCommand
     */
    department: string;
    /**
     * Stop date.
     * @type {string}
     * @memberof RequestStopDepartmentCommand
     */
    stopDate: string;
    /**
     * Reason
     * @type {string}
     * @memberof RequestStopDepartmentCommand
     */
    reason: string;
}
/**
 * Request to stop department.
 * @export
 * @interface RequestStopDepartmentCommandAllOf
 */
export interface RequestStopDepartmentCommandAllOf {
    /**
     * Department.
     * @type {string}
     * @memberof RequestStopDepartmentCommandAllOf
     */
    department: string;
    /**
     * Stop date.
     * @type {string}
     * @memberof RequestStopDepartmentCommandAllOf
     */
    stopDate: string;
    /**
     * Reason
     * @type {string}
     * @memberof RequestStopDepartmentCommandAllOf
     */
    reason: string;
}
/**
 * Reset password.
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * Token.
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    passwordResetToken: string;
    /**
     * New password.
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    password: string;
}
/**
 * Type of scroll
 * @export
 * @enum {string}
 */

export enum ScrollType {
    Combidose = 'Combidose',
    Multidose = 'Multidose'
}

/**
 * Scroll weeks.
 * @export
 * @enum {string}
 */

export enum ScrollWeeks {
    OneWeek = 'OneWeek',
    TwoWeeks = 'TwoWeeks',
    ThreeWeeks = 'ThreeWeeks',
    FourWeeks = 'FourWeeks',
    Other = 'Other'
}

/**
 * 
 * @export
 * @interface SearchColumn
 */
export interface SearchColumn {
    /**
     * 
     * @type {string}
     * @memberof SearchColumn
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchColumn
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface SearchPatientQuery
 */
export interface SearchPatientQuery {
    /**
     * Filter to search by
     * @type {string}
     * @memberof SearchPatientQuery
     */
    filter: string;
}
/**
 * Search patients matching provided filter. Only patiens for current pharmacy will be returned.
 * @export
 * @interface SearchPatientQueryAllOf
 */
export interface SearchPatientQueryAllOf {
    /**
     * Filter to search by
     * @type {string}
     * @memberof SearchPatientQueryAllOf
     */
    filter: string;
}
/**
 * 
 * @export
 * @interface ServiceProductDto
 */
export interface ServiceProductDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceProductDto
     */
    serviceProductId?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductDto
     */
    articleCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceProductDto
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductDto
     */
    imageUri?: string | null;
}
/**
 * 
 * @export
 * @interface ServiceProductOrderDto
 */
export interface ServiceProductOrderDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderDto
     */
    serviceProductOrderId?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductOrderDto
     */
    requesterName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductOrderDto
     */
    requesterEmail?: string | null;
    /**
     * 
     * @type {ServiceProductOrderStatus}
     * @memberof ServiceProductOrderDto
     */
    status?: ServiceProductOrderStatus;
    /**
     * Pharmacist that created this order. Null if order was created through backoffice.
     * @type {number}
     * @memberof ServiceProductOrderDto
     */
    createdByPharmacistAccountId?: number | null;
    /**
     * Pharmacist that created this order. Null if order was created through backoffice.
     * @type {string}
     * @memberof ServiceProductOrderDto
     */
    createdByPharmacistEmailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductOrderDto
     */
    createDate?: string;
    /**
     * 
     * @type {Array<ServiceProductOrderRowDto>}
     * @memberof ServiceProductOrderDto
     */
    orderRows?: Array<ServiceProductOrderRowDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderDto
     */
    orderTotalPrice?: number;
}
/**
 * 
 * @export
 * @interface ServiceProductOrderRowDto
 */
export interface ServiceProductOrderRowDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderRowDto
     */
    serviceProductOrderRowId?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderRowDto
     */
    rowNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderRowDto
     */
    serviceProductId?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductOrderRowDto
     */
    serviceProductArticleCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductOrderRowDto
     */
    serviceProductName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderRowDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderRowDto
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderRowDto
     */
    rowTotalPrice?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ServiceProductOrderStatus {
    New = 'New',
    Processing = 'Processing',
    Archived = 'Archived'
}

/**
 * 
 * @export
 * @interface ServiceProductOrderTableDto
 */
export interface ServiceProductOrderTableDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceProductOrderTableDto
     */
    serviceProductOrderId?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceProductOrderTableDto
     */
    requesterName?: string | null;
    /**
     * 
     * @type {ServiceProductOrderStatus}
     * @memberof ServiceProductOrderTableDto
     */
    status?: ServiceProductOrderStatus;
}
/**
 * 
 * @export
 * @interface TotpSetupCodeDto
 */
export interface TotpSetupCodeDto {
    /**
     * The QR code, which can be rendered as an image.
     * @type {string}
     * @memberof TotpSetupCodeDto
     */
    qrSetupCode?: string | null;
    /**
     * For manual entry, if the QR code can not be scanned.
     * @type {string}
     * @memberof TotpSetupCodeDto
     */
    manualEntryKey?: string | null;
    /**
     * The QR code, already rendered as a base64 encoded PNG image.
     * @type {string}
     * @memberof TotpSetupCodeDto
     */
    qrSetupCodeImage?: string | null;
}
/**
 * Update password.
 * @export
 * @interface UpdatePasswordRequest
 */
export interface UpdatePasswordRequest {
    /**
     * Current password.
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    currentPassword: string;
    /**
     * New password.
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    newPassword: string;
}
/**
 * 
 * @export
 * @interface UpdatePharmacistCommand
 */
export interface UpdatePharmacistCommand {
    /**
     * Id of the pharmacist account
     * @type {number}
     * @memberof UpdatePharmacistCommand
     */
    accountId: number;
    /**
     * Sets if account is active
     * @type {boolean}
     * @memberof UpdatePharmacistCommand
     */
    isDisabled: boolean;
    /**
     * Type of Pharmacist  can be:  Employee  or  Management
     * @type {PharmacistType}
     * @memberof UpdatePharmacistCommand
     */
    pharmacistType: PharmacistType;
}
/**
 * Command to update Pharmacist for managers.
 * @export
 * @interface UpdatePharmacistCommandAllOf
 */
export interface UpdatePharmacistCommandAllOf {
    /**
     * Id of the pharmacist account
     * @type {number}
     * @memberof UpdatePharmacistCommandAllOf
     */
    accountId: number;
    /**
     * Sets if account is active
     * @type {boolean}
     * @memberof UpdatePharmacistCommandAllOf
     */
    isDisabled: boolean;
    /**
     * Type of Pharmacist  can be:  Employee  or  Management
     * @type {PharmacistType}
     * @memberof UpdatePharmacistCommandAllOf
     */
    pharmacistType: PharmacistType;
}
/**
 * Update pharmacist.
 * @export
 * @interface UpdatePharmacistRequest
 */
export interface UpdatePharmacistRequest {
    /**
     * Account id.
     * @type {number}
     * @memberof UpdatePharmacistRequest
     */
    accountId: number;
    /**
     * Email address.
     * @type {string}
     * @memberof UpdatePharmacistRequest
     */
    emailAddress: string;
    /**
     * First name.
     * @type {string}
     * @memberof UpdatePharmacistRequest
     */
    firstName: string;
    /**
     * Middle name.
     * @type {string}
     * @memberof UpdatePharmacistRequest
     */
    middleName?: string | null;
    /**
     * Last name.
     * @type {string}
     * @memberof UpdatePharmacistRequest
     */
    lastName: string;
    /**
     * Pharmacist type.
     * @type {PharmacistType}
     * @memberof UpdatePharmacistRequest
     */
    pharmacistType: PharmacistType;
}
/**
 * User info.
 * @export
 * @interface UserInfoDto
 */
export interface UserInfoDto {
    /**
     * Email address.
     * @type {string}
     * @memberof UserInfoDto
     */
    emailAddress?: string | null;
    /**
     * First name.
     * @type {string}
     * @memberof UserInfoDto
     */
    firstName?: string | null;
    /**
     * Is user administrator or normal user.
     * @type {boolean}
     * @memberof UserInfoDto
     */
    isAdministrator?: boolean;
    /**
     * Is manager for portal.
     * @type {boolean}
     * @memberof UserInfoDto
     */
    isManager?: boolean;
}
/**
 * 
 * @export
 * @interface VueTableRequest
 */
export interface VueTableRequest {
    /**
     * 
     * @type {any}
     * @memberof VueTableRequest
     */
    sortBy?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VueTableRequest
     */
    descending?: any | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof VueTableRequest
     */
    rowsPerPage: number;
    /**
     * 
     * @type {string}
     * @memberof VueTableRequest
     */
    search?: string | null;
    /**
     * 
     * @type {Array<SearchColumn>}
     * @memberof VueTableRequest
     */
    searchColumns?: Array<SearchColumn> | null;
}
/**
 * 
 * @export
 * @interface VueTableResponseOfDrugTableDto
 */
export interface VueTableResponseOfDrugTableDto {
    /**
     * 
     * @type {Array<DrugTableDto>}
     * @memberof VueTableResponseOfDrugTableDto
     */
    items?: Array<DrugTableDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableResponseOfDrugTableDto
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface VueTableResponseOfInvoiceTableDto
 */
export interface VueTableResponseOfInvoiceTableDto {
    /**
     * 
     * @type {Array<InvoiceTableDto>}
     * @memberof VueTableResponseOfInvoiceTableDto
     */
    items?: Array<InvoiceTableDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableResponseOfInvoiceTableDto
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface VueTableResponseOfOrderFulfillmentScheduleDto
 */
export interface VueTableResponseOfOrderFulfillmentScheduleDto {
    /**
     * 
     * @type {Array<OrderFulfillmentScheduleDto>}
     * @memberof VueTableResponseOfOrderFulfillmentScheduleDto
     */
    items?: Array<OrderFulfillmentScheduleDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableResponseOfOrderFulfillmentScheduleDto
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface VueTableResponseOfOrderFulfillmentTableDto
 */
export interface VueTableResponseOfOrderFulfillmentTableDto {
    /**
     * 
     * @type {Array<OrderFulfillmentTableDto>}
     * @memberof VueTableResponseOfOrderFulfillmentTableDto
     */
    items?: Array<OrderFulfillmentTableDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableResponseOfOrderFulfillmentTableDto
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface VueTableResponseOfPharmacistTableDto
 */
export interface VueTableResponseOfPharmacistTableDto {
    /**
     * 
     * @type {Array<PharmacistTableDto>}
     * @memberof VueTableResponseOfPharmacistTableDto
     */
    items?: Array<PharmacistTableDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableResponseOfPharmacistTableDto
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface VueTableResponseOfPharmacistTableDto2
 */
export interface VueTableResponseOfPharmacistTableDto2 {
    /**
     * 
     * @type {Array<PharmacistTableDto2>}
     * @memberof VueTableResponseOfPharmacistTableDto2
     */
    items?: Array<PharmacistTableDto2> | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableResponseOfPharmacistTableDto2
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface VueTableResponseOfServiceProductOrderTableDto
 */
export interface VueTableResponseOfServiceProductOrderTableDto {
    /**
     * 
     * @type {Array<ServiceProductOrderTableDto>}
     * @memberof VueTableResponseOfServiceProductOrderTableDto
     */
    items?: Array<ServiceProductOrderTableDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VueTableResponseOfServiceProductOrderTableDto
     */
    total?: number;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Disable 2FA using Totp for the current user.
         * @param {DisableTotpRequest} disableTotpRequest Request providing info needed to disable Totp.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDisableTotp: async (disableTotpRequest: DisableTotpRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'disableTotpRequest' is not null or undefined
            assertParamExists('accountDisableTotp', 'disableTotpRequest', disableTotpRequest)
            const localVarPath = `/api/portal/Account/DisableTotp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disableTotpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable 2FA using Totp (Time-based One-time Password). A setup code should first be requested.
         * @param {EnableTotpRequest} enableTotpRequest Request providing info needed to enable Totp.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountEnableTotp: async (enableTotpRequest: EnableTotpRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'enableTotpRequest' is not null or undefined
            assertParamExists('accountEnableTotp', 'enableTotpRequest', enableTotpRequest)
            const localVarPath = `/api/portal/Account/EnableTotp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableTotpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the setup code needed to enable 2FA using Totp (Time-based One-time Password).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetTotpSetupCode: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Account/GetTotpSetupCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if 2FA using Totp (Time-based One-time Password) is currently enabled for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountIsTotpEnabled: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Account/IsTotpEnabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the password of the currently logged in user.
         * @param {UpdatePasswordRequest} updatePasswordRequest Request providing the new password details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdatePassword: async (updatePasswordRequest: UpdatePasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePasswordRequest' is not null or undefined
            assertParamExists('accountUpdatePassword', 'updatePasswordRequest', updatePasswordRequest)
            const localVarPath = `/api/portal/Account/UpdatePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Disable 2FA using Totp for the current user.
         * @param {DisableTotpRequest} disableTotpRequest Request providing info needed to disable Totp.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountDisableTotp(disableTotpRequest: DisableTotpRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountDisableTotp(disableTotpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable 2FA using Totp (Time-based One-time Password). A setup code should first be requested.
         * @param {EnableTotpRequest} enableTotpRequest Request providing info needed to enable Totp.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountEnableTotp(enableTotpRequest: EnableTotpRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountEnableTotp(enableTotpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the setup code needed to enable 2FA using Totp (Time-based One-time Password).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountGetTotpSetupCode(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotpSetupCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountGetTotpSetupCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if 2FA using Totp (Time-based One-time Password) is currently enabled for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountIsTotpEnabled(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountIsTotpEnabled(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the password of the currently logged in user.
         * @param {UpdatePasswordRequest} updatePasswordRequest Request providing the new password details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUpdatePassword(updatePasswordRequest: UpdatePasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUpdatePassword(updatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary Disable 2FA using Totp for the current user.
         * @param {DisableTotpRequest} disableTotpRequest Request providing info needed to disable Totp.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDisableTotp(disableTotpRequest: DisableTotpRequest, options?: any): AxiosPromise<void> {
            return localVarFp.accountDisableTotp(disableTotpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable 2FA using Totp (Time-based One-time Password). A setup code should first be requested.
         * @param {EnableTotpRequest} enableTotpRequest Request providing info needed to enable Totp.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountEnableTotp(enableTotpRequest: EnableTotpRequest, options?: any): AxiosPromise<void> {
            return localVarFp.accountEnableTotp(enableTotpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the setup code needed to enable 2FA using Totp (Time-based One-time Password).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountGetTotpSetupCode(options?: any): AxiosPromise<TotpSetupCodeDto> {
            return localVarFp.accountGetTotpSetupCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if 2FA using Totp (Time-based One-time Password) is currently enabled for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountIsTotpEnabled(options?: any): AxiosPromise<boolean> {
            return localVarFp.accountIsTotpEnabled(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the password of the currently logged in user.
         * @param {UpdatePasswordRequest} updatePasswordRequest Request providing the new password details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdatePassword(updatePasswordRequest: UpdatePasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.accountUpdatePassword(updatePasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary Disable 2FA using Totp for the current user.
     * @param {DisableTotpRequest} disableTotpRequest Request providing info needed to disable Totp.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountDisableTotp(disableTotpRequest: DisableTotpRequest, options?: any) {
        return AccountApiFp(this.configuration).accountDisableTotp(disableTotpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable 2FA using Totp (Time-based One-time Password). A setup code should first be requested.
     * @param {EnableTotpRequest} enableTotpRequest Request providing info needed to enable Totp.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountEnableTotp(enableTotpRequest: EnableTotpRequest, options?: any) {
        return AccountApiFp(this.configuration).accountEnableTotp(enableTotpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the setup code needed to enable 2FA using Totp (Time-based One-time Password).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountGetTotpSetupCode(options?: any) {
        return AccountApiFp(this.configuration).accountGetTotpSetupCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if 2FA using Totp (Time-based One-time Password) is currently enabled for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountIsTotpEnabled(options?: any) {
        return AccountApiFp(this.configuration).accountIsTotpEnabled(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the password of the currently logged in user.
     * @param {UpdatePasswordRequest} updatePasswordRequest Request providing the new password details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUpdatePassword(updatePasswordRequest: UpdatePasswordRequest, options?: any) {
        return AccountApiFp(this.configuration).accountUpdatePassword(updatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccountManagementApi - axios parameter creator
 * @export
 */
export const AccountManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new pharmacist the the pharmacy attached to the logged in user.
         * @param {AddPharmacistCommand} addPharmacistCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountManagementAddPharmacist: async (addPharmacistCommand: AddPharmacistCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addPharmacistCommand' is not null or undefined
            assertParamExists('accountManagementAddPharmacist', 'addPharmacistCommand', addPharmacistCommand)
            const localVarPath = `/api/portal/AccountManagement/AddPharmacist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPharmacistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get phamracist table.
         * @param {VueTableRequest} vueTableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountManagementGetPharmacistsTable: async (vueTableRequest: VueTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vueTableRequest' is not null or undefined
            assertParamExists('accountManagementGetPharmacistsTable', 'vueTableRequest', vueTableRequest)
            const localVarPath = `/api/portal/AccountManagement/GetPharmacistsTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vueTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update pharmacist account.
         * @param {UpdatePharmacistCommand} updatePharmacistCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountManagementUpdatePharmacistAccount: async (updatePharmacistCommand: UpdatePharmacistCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePharmacistCommand' is not null or undefined
            assertParamExists('accountManagementUpdatePharmacistAccount', 'updatePharmacistCommand', updatePharmacistCommand)
            const localVarPath = `/api/portal/AccountManagement/UpdatePharmacistAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePharmacistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountManagementApi - functional programming interface
 * @export
 */
export const AccountManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new pharmacist the the pharmacy attached to the logged in user.
         * @param {AddPharmacistCommand} addPharmacistCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountManagementAddPharmacist(addPharmacistCommand: AddPharmacistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountManagementAddPharmacist(addPharmacistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get phamracist table.
         * @param {VueTableRequest} vueTableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountManagementGetPharmacistsTable(vueTableRequest: VueTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VueTableResponseOfPharmacistTableDto2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountManagementGetPharmacistsTable(vueTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update pharmacist account.
         * @param {UpdatePharmacistCommand} updatePharmacistCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountManagementUpdatePharmacistAccount(updatePharmacistCommand: UpdatePharmacistCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountManagementUpdatePharmacistAccount(updatePharmacistCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountManagementApi - factory interface
 * @export
 */
export const AccountManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new pharmacist the the pharmacy attached to the logged in user.
         * @param {AddPharmacistCommand} addPharmacistCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountManagementAddPharmacist(addPharmacistCommand: AddPharmacistCommand, options?: any): AxiosPromise<number> {
            return localVarFp.accountManagementAddPharmacist(addPharmacistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get phamracist table.
         * @param {VueTableRequest} vueTableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountManagementGetPharmacistsTable(vueTableRequest: VueTableRequest, options?: any): AxiosPromise<VueTableResponseOfPharmacistTableDto2> {
            return localVarFp.accountManagementGetPharmacistsTable(vueTableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update pharmacist account.
         * @param {UpdatePharmacistCommand} updatePharmacistCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountManagementUpdatePharmacistAccount(updatePharmacistCommand: UpdatePharmacistCommand, options?: any): AxiosPromise<void> {
            return localVarFp.accountManagementUpdatePharmacistAccount(updatePharmacistCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountManagementApi - object-oriented interface
 * @export
 * @class AccountManagementApi
 * @extends {BaseAPI}
 */
export class AccountManagementApi extends BaseAPI {
    /**
     * 
     * @summary Add a new pharmacist the the pharmacy attached to the logged in user.
     * @param {AddPharmacistCommand} addPharmacistCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountManagementAddPharmacist(addPharmacistCommand: AddPharmacistCommand, options?: any) {
        return AccountManagementApiFp(this.configuration).accountManagementAddPharmacist(addPharmacistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get phamracist table.
     * @param {VueTableRequest} vueTableRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountManagementGetPharmacistsTable(vueTableRequest: VueTableRequest, options?: any) {
        return AccountManagementApiFp(this.configuration).accountManagementGetPharmacistsTable(vueTableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update pharmacist account.
     * @param {UpdatePharmacistCommand} updatePharmacistCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountManagementUpdatePharmacistAccount(updatePharmacistCommand: UpdatePharmacistCommand, options?: any) {
        return AccountManagementApiFp(this.configuration).accountManagementUpdatePharmacistAccount(updatePharmacistCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AssortmentUpdateApi - axios parameter creator
 * @export
 */
export const AssortmentUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download latest assortment update file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assortmentUpdateDownloadAssortmentUpdate: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/AssortmentUpdate/DownloadAssortmentUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the datetime of last write time of the latest assortmentupdate. Returns null when no file is found.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assortmentUpdateGetLatestAssortmentWriteTime: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/AssortmentUpdate/GetLatestAssortmentWriteTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssortmentUpdateApi - functional programming interface
 * @export
 */
export const AssortmentUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssortmentUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download latest assortment update file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assortmentUpdateDownloadAssortmentUpdate(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assortmentUpdateDownloadAssortmentUpdate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the datetime of last write time of the latest assortmentupdate. Returns null when no file is found.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assortmentUpdateGetLatestAssortmentWriteTime(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assortmentUpdateGetLatestAssortmentWriteTime(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssortmentUpdateApi - factory interface
 * @export
 */
export const AssortmentUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssortmentUpdateApiFp(configuration)
    return {
        /**
         * 
         * @summary Download latest assortment update file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assortmentUpdateDownloadAssortmentUpdate(options?: any): AxiosPromise<void> {
            return localVarFp.assortmentUpdateDownloadAssortmentUpdate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the datetime of last write time of the latest assortmentupdate. Returns null when no file is found.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assortmentUpdateGetLatestAssortmentWriteTime(options?: any): AxiosPromise<string> {
            return localVarFp.assortmentUpdateGetLatestAssortmentWriteTime(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssortmentUpdateApi - object-oriented interface
 * @export
 * @class AssortmentUpdateApi
 * @extends {BaseAPI}
 */
export class AssortmentUpdateApi extends BaseAPI {
    /**
     * 
     * @summary Download latest assortment update file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssortmentUpdateApi
     */
    public assortmentUpdateDownloadAssortmentUpdate(options?: any) {
        return AssortmentUpdateApiFp(this.configuration).assortmentUpdateDownloadAssortmentUpdate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the datetime of last write time of the latest assortmentupdate. Returns null when no file is found.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssortmentUpdateApi
     */
    public assortmentUpdateGetLatestAssortmentWriteTime(options?: any) {
        return AssortmentUpdateApiFp(this.configuration).assortmentUpdateGetLatestAssortmentWriteTime(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate an account and set the password.
         * @param {ActivateAccountRequest} activateAccountRequest Request providing the activation details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationActivateAccount: async (activateAccountRequest: ActivateAccountRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'activateAccountRequest' is not null or undefined
            assertParamExists('authenticationActivateAccount', 'activateAccountRequest', activateAccountRequest)
            const localVarPath = `/api/portal/Authentication/ActivateAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if an account activation token is valid.
         * @param {IsActivationTokenValidRequest} isActivationTokenValidRequest Request providing the activation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationIsActivationKeyValid: async (isActivationTokenValidRequest: IsActivationTokenValidRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'isActivationTokenValidRequest' is not null or undefined
            assertParamExists('authenticationIsActivationKeyValid', 'isActivationTokenValidRequest', isActivationTokenValidRequest)
            const localVarPath = `/api/portal/Authentication/IsActivationKeyValid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(isActivationTokenValidRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a password reset token is valid.
         * @param {IsPasswordResetTokenValidRequest} isPasswordResetTokenValidRequest Request providing the token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationIsPasswordResetTokenValid: async (isPasswordResetTokenValidRequest: IsPasswordResetTokenValidRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'isPasswordResetTokenValidRequest' is not null or undefined
            assertParamExists('authenticationIsPasswordResetTokenValid', 'isPasswordResetTokenValidRequest', isPasswordResetTokenValidRequest)
            const localVarPath = `/api/portal/Authentication/IsPasswordResetTokenValid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(isPasswordResetTokenValidRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with credentials.
         * @param {LoginWithCredentialsRequest} loginWithCredentialsRequest Request providing the login details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationLoginWithCredentials: async (loginWithCredentialsRequest: LoginWithCredentialsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginWithCredentialsRequest' is not null or undefined
            assertParamExists('authenticationLoginWithCredentials', 'loginWithCredentialsRequest', loginWithCredentialsRequest)
            const localVarPath = `/api/portal/Authentication/LoginWithCredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithCredentialsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with credentials and Totp.
         * @param {LoginWithTotpRequest} loginWithTotpRequest Request providing the login details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationLoginWithTotp: async (loginWithTotpRequest: LoginWithTotpRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginWithTotpRequest' is not null or undefined
            assertParamExists('authenticationLoginWithTotp', 'loginWithTotpRequest', loginWithTotpRequest)
            const localVarPath = `/api/portal/Authentication/LoginWithTotp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithTotpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout. This invalidates the current JWT for future use.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationLogout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Authentication/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh an (expired) access token.
         * @param {RefreshAccessTokenRequest} refreshAccessTokenRequest Request providing the current token details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationRefreshAccessToken: async (refreshAccessTokenRequest: RefreshAccessTokenRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshAccessTokenRequest' is not null or undefined
            assertParamExists('authenticationRefreshAccessToken', 'refreshAccessTokenRequest', refreshAccessTokenRequest)
            const localVarPath = `/api/portal/Authentication/RefreshAccessToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshAccessTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a token (via email) to reset the password of the requested account. With this token a new password can be set. This will always return NoContent, even if the requested account does not exist.
         * @param {RequestPasswordResetTokenRequest} requestPasswordResetTokenRequest Request indicating the account for which a new password is requested.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationRequestPasswordResetToken: async (requestPasswordResetTokenRequest: RequestPasswordResetTokenRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPasswordResetTokenRequest' is not null or undefined
            assertParamExists('authenticationRequestPasswordResetToken', 'requestPasswordResetTokenRequest', requestPasswordResetTokenRequest)
            const localVarPath = `/api/portal/Authentication/RequestPasswordResetToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordResetTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset a password using the provided password reset token.
         * @param {ResetPasswordRequest} resetPasswordRequest Request providing the new password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationResetPassword: async (resetPasswordRequest: ResetPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('authenticationResetPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/api/portal/Authentication/ResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate an account and set the password.
         * @param {ActivateAccountRequest} activateAccountRequest Request providing the activation details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationActivateAccount(activateAccountRequest: ActivateAccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationActivateAccount(activateAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if an account activation token is valid.
         * @param {IsActivationTokenValidRequest} isActivationTokenValidRequest Request providing the activation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationIsActivationKeyValid(isActivationTokenValidRequest: IsActivationTokenValidRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationIsActivationKeyValid(isActivationTokenValidRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if a password reset token is valid.
         * @param {IsPasswordResetTokenValidRequest} isPasswordResetTokenValidRequest Request providing the token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationIsPasswordResetTokenValid(isPasswordResetTokenValidRequest: IsPasswordResetTokenValidRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationIsPasswordResetTokenValid(isPasswordResetTokenValidRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with credentials.
         * @param {LoginWithCredentialsRequest} loginWithCredentialsRequest Request providing the login details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationLoginWithCredentials(loginWithCredentialsRequest: LoginWithCredentialsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationLoginWithCredentials(loginWithCredentialsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with credentials and Totp.
         * @param {LoginWithTotpRequest} loginWithTotpRequest Request providing the login details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationLoginWithTotp(loginWithTotpRequest: LoginWithTotpRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationLoginWithTotp(loginWithTotpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout. This invalidates the current JWT for future use.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationLogout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Refresh an (expired) access token.
         * @param {RefreshAccessTokenRequest} refreshAccessTokenRequest Request providing the current token details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationRefreshAccessToken(refreshAccessTokenRequest: RefreshAccessTokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationRefreshAccessToken(refreshAccessTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request a token (via email) to reset the password of the requested account. With this token a new password can be set. This will always return NoContent, even if the requested account does not exist.
         * @param {RequestPasswordResetTokenRequest} requestPasswordResetTokenRequest Request indicating the account for which a new password is requested.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationRequestPasswordResetToken(requestPasswordResetTokenRequest: RequestPasswordResetTokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationRequestPasswordResetToken(requestPasswordResetTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset a password using the provided password reset token.
         * @param {ResetPasswordRequest} resetPasswordRequest Request providing the new password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationResetPassword(resetPasswordRequest: ResetPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationResetPassword(resetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate an account and set the password.
         * @param {ActivateAccountRequest} activateAccountRequest Request providing the activation details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationActivateAccount(activateAccountRequest: ActivateAccountRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticationActivateAccount(activateAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if an account activation token is valid.
         * @param {IsActivationTokenValidRequest} isActivationTokenValidRequest Request providing the activation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationIsActivationKeyValid(isActivationTokenValidRequest: IsActivationTokenValidRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticationIsActivationKeyValid(isActivationTokenValidRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a password reset token is valid.
         * @param {IsPasswordResetTokenValidRequest} isPasswordResetTokenValidRequest Request providing the token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationIsPasswordResetTokenValid(isPasswordResetTokenValidRequest: IsPasswordResetTokenValidRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticationIsPasswordResetTokenValid(isPasswordResetTokenValidRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with credentials.
         * @param {LoginWithCredentialsRequest} loginWithCredentialsRequest Request providing the login details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationLoginWithCredentials(loginWithCredentialsRequest: LoginWithCredentialsRequest, options?: any): AxiosPromise<AuthorizedResultDto> {
            return localVarFp.authenticationLoginWithCredentials(loginWithCredentialsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with credentials and Totp.
         * @param {LoginWithTotpRequest} loginWithTotpRequest Request providing the login details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationLoginWithTotp(loginWithTotpRequest: LoginWithTotpRequest, options?: any): AxiosPromise<AuthorizedResultDto> {
            return localVarFp.authenticationLoginWithTotp(loginWithTotpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout. This invalidates the current JWT for future use.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationLogout(options?: any): AxiosPromise<void> {
            return localVarFp.authenticationLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh an (expired) access token.
         * @param {RefreshAccessTokenRequest} refreshAccessTokenRequest Request providing the current token details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationRefreshAccessToken(refreshAccessTokenRequest: RefreshAccessTokenRequest, options?: any): AxiosPromise<AuthorizedResultDto> {
            return localVarFp.authenticationRefreshAccessToken(refreshAccessTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a token (via email) to reset the password of the requested account. With this token a new password can be set. This will always return NoContent, even if the requested account does not exist.
         * @param {RequestPasswordResetTokenRequest} requestPasswordResetTokenRequest Request indicating the account for which a new password is requested.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationRequestPasswordResetToken(requestPasswordResetTokenRequest: RequestPasswordResetTokenRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticationRequestPasswordResetToken(requestPasswordResetTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset a password using the provided password reset token.
         * @param {ResetPasswordRequest} resetPasswordRequest Request providing the new password.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationResetPassword(resetPasswordRequest: ResetPasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticationResetPassword(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Activate an account and set the password.
     * @param {ActivateAccountRequest} activateAccountRequest Request providing the activation details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationActivateAccount(activateAccountRequest: ActivateAccountRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationActivateAccount(activateAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if an account activation token is valid.
     * @param {IsActivationTokenValidRequest} isActivationTokenValidRequest Request providing the activation token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationIsActivationKeyValid(isActivationTokenValidRequest: IsActivationTokenValidRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationIsActivationKeyValid(isActivationTokenValidRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a password reset token is valid.
     * @param {IsPasswordResetTokenValidRequest} isPasswordResetTokenValidRequest Request providing the token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationIsPasswordResetTokenValid(isPasswordResetTokenValidRequest: IsPasswordResetTokenValidRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationIsPasswordResetTokenValid(isPasswordResetTokenValidRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with credentials.
     * @param {LoginWithCredentialsRequest} loginWithCredentialsRequest Request providing the login details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationLoginWithCredentials(loginWithCredentialsRequest: LoginWithCredentialsRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationLoginWithCredentials(loginWithCredentialsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with credentials and Totp.
     * @param {LoginWithTotpRequest} loginWithTotpRequest Request providing the login details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationLoginWithTotp(loginWithTotpRequest: LoginWithTotpRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationLoginWithTotp(loginWithTotpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout. This invalidates the current JWT for future use.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationLogout(options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh an (expired) access token.
     * @param {RefreshAccessTokenRequest} refreshAccessTokenRequest Request providing the current token details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationRefreshAccessToken(refreshAccessTokenRequest: RefreshAccessTokenRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationRefreshAccessToken(refreshAccessTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a token (via email) to reset the password of the requested account. With this token a new password can be set. This will always return NoContent, even if the requested account does not exist.
     * @param {RequestPasswordResetTokenRequest} requestPasswordResetTokenRequest Request indicating the account for which a new password is requested.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationRequestPasswordResetToken(requestPasswordResetTokenRequest: RequestPasswordResetTokenRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationRequestPasswordResetToken(requestPasswordResetTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset a password using the provided password reset token.
     * @param {ResetPasswordRequest} resetPasswordRequest Request providing the new password.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationResetPassword(resetPasswordRequest: ResetPasswordRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationResetPassword(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContactDetailsApi - axios parameter creator
 * @export
 */
export const ContactDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contact details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactDetailsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/ContactDetails/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactDetailsApi - functional programming interface
 * @export
 */
export const ContactDetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactDetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get contact details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactDetailsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactDetailsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactDetailsApi - factory interface
 * @export
 */
export const ContactDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactDetailsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get contact details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactDetailsGet(options?: any): AxiosPromise<void> {
            return localVarFp.contactDetailsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactDetailsApi - object-oriented interface
 * @export
 * @class ContactDetailsApi
 * @extends {BaseAPI}
 */
export class ContactDetailsApi extends BaseAPI {
    /**
     * 
     * @summary Get contact details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactDetailsApi
     */
    public contactDetailsGet(options?: any) {
        return ContactDetailsApiFp(this.configuration).contactDetailsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of Umbraco content items by page id.
         * @param {number} [pageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentGetContentItems: async (pageId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Content/GetContentItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageId !== undefined) {
                localVarQueryParameter['pageId'] = pageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a list of Umbraco content items by page id.
         * @param {number} [pageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentGetContentItems(pageId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentGetContentItems(pageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a list of Umbraco content items by page id.
         * @param {number} [pageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentGetContentItems(pageId?: number, options?: any): AxiosPromise<Array<any>> {
            return localVarFp.contentGetContentItems(pageId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
    /**
     * 
     * @summary Get a list of Umbraco content items by page id.
     * @param {number} [pageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public contentGetContentItems(pageId?: number, options?: any) {
        return ContentApiFp(this.configuration).contentGetContentItems(pageId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DrugApi - axios parameter creator
 * @export
 */
export const DrugApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export some properties of assortment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugExportAssortmentToCsv: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Drug/ExportAssortmentToCsv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export some properites of assortment excel.
         * @param {ExportAssortmentToExcelQuery} exportAssortmentToExcelQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugExportAssortmentToExcel: async (exportAssortmentToExcelQuery: ExportAssortmentToExcelQuery, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportAssortmentToExcelQuery' is not null or undefined
            assertParamExists('drugExportAssortmentToExcel', 'exportAssortmentToExcelQuery', exportAssortmentToExcelQuery)
            const localVarPath = `/api/portal/Drug/ExportAssortmentToExcel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportAssortmentToExcelQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all drugs as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugGetDrugTable: async (vueTableRequest: VueTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vueTableRequest' is not null or undefined
            assertParamExists('drugGetDrugTable', 'vueTableRequest', vueTableRequest)
            const localVarPath = `/api/portal/Drug/GetDrugTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vueTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DrugApi - functional programming interface
 * @export
 */
export const DrugApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DrugApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export some properties of assortment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async drugExportAssortmentToCsv(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.drugExportAssortmentToCsv(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export some properites of assortment excel.
         * @param {ExportAssortmentToExcelQuery} exportAssortmentToExcelQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async drugExportAssortmentToExcel(exportAssortmentToExcelQuery: ExportAssortmentToExcelQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.drugExportAssortmentToExcel(exportAssortmentToExcelQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of all drugs as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async drugGetDrugTable(vueTableRequest: VueTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VueTableResponseOfDrugTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.drugGetDrugTable(vueTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DrugApi - factory interface
 * @export
 */
export const DrugApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DrugApiFp(configuration)
    return {
        /**
         * 
         * @summary Export some properties of assortment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugExportAssortmentToCsv(options?: any): AxiosPromise<string> {
            return localVarFp.drugExportAssortmentToCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export some properites of assortment excel.
         * @param {ExportAssortmentToExcelQuery} exportAssortmentToExcelQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugExportAssortmentToExcel(exportAssortmentToExcelQuery: ExportAssortmentToExcelQuery, options?: any): AxiosPromise<string> {
            return localVarFp.drugExportAssortmentToExcel(exportAssortmentToExcelQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all drugs as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugGetDrugTable(vueTableRequest: VueTableRequest, options?: any): AxiosPromise<VueTableResponseOfDrugTableDto> {
            return localVarFp.drugGetDrugTable(vueTableRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DrugApi - object-oriented interface
 * @export
 * @class DrugApi
 * @extends {BaseAPI}
 */
export class DrugApi extends BaseAPI {
    /**
     * 
     * @summary Export some properties of assortment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrugApi
     */
    public drugExportAssortmentToCsv(options?: any) {
        return DrugApiFp(this.configuration).drugExportAssortmentToCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export some properites of assortment excel.
     * @param {ExportAssortmentToExcelQuery} exportAssortmentToExcelQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrugApi
     */
    public drugExportAssortmentToExcel(exportAssortmentToExcelQuery: ExportAssortmentToExcelQuery, options?: any) {
        return DrugApiFp(this.configuration).drugExportAssortmentToExcel(exportAssortmentToExcelQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all drugs as a VueTableResponse.
     * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrugApi
     */
    public drugGetDrugTable(vueTableRequest: VueTableRequest, options?: any) {
        return DrugApiFp(this.configuration).drugGetDrugTable(vueTableRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FaqApi - axios parameter creator
 * @export
 */
export const FaqApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of all faq items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqGetFaqItems: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Faq/GetFaqItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FaqApi - functional programming interface
 * @export
 */
export const FaqApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FaqApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a list of all faq items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async faqGetFaqItems(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FaqItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.faqGetFaqItems(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FaqApi - factory interface
 * @export
 */
export const FaqApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FaqApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a list of all faq items.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqGetFaqItems(options?: any): AxiosPromise<Array<FaqItemDto>> {
            return localVarFp.faqGetFaqItems(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FaqApi - object-oriented interface
 * @export
 * @class FaqApi
 * @extends {BaseAPI}
 */
export class FaqApi extends BaseAPI {
    /**
     * 
     * @summary Get a list of all faq items.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqApi
     */
    public faqGetFaqItems(options?: any) {
        return FaqApiFp(this.configuration).faqGetFaqItems(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the location and description of the file by id.
         * @param {string} [guid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetFile: async (guid?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/File/GetFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete file. (Cancelling the upload with FilePond plugin.) Must provide the fileGuid in the body of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadFileDELETE: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/File/UploadFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file.
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {IHeaderDictionary} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadFilePOST: async (contentType?: string, contentDisposition?: string, headers?: IHeaderDictionary, length?: number, name?: string, fileName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/File/UploadFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }
    
            if (headers !== undefined) { 
                localVarFormParams.append('Headers', new Blob([JSON.stringify(headers)], { type: "application/json", }));
            }
    
            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the location and description of the file by id.
         * @param {string} [guid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileGetFile(guid?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileGetFile(guid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete file. (Cancelling the upload with FilePond plugin.) Must provide the fileGuid in the body of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadFileDELETE(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUploadFileDELETE(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload a file.
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {IHeaderDictionary} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadFilePOST(contentType?: string, contentDisposition?: string, headers?: IHeaderDictionary, length?: number, name?: string, fileName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUploadFilePOST(contentType, contentDisposition, headers, length, name, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the location and description of the file by id.
         * @param {string} [guid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetFile(guid?: string, options?: any): AxiosPromise<GetFileResponse> {
            return localVarFp.fileGetFile(guid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete file. (Cancelling the upload with FilePond plugin.) Must provide the fileGuid in the body of the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadFileDELETE(options?: any): AxiosPromise<void> {
            return localVarFp.fileUploadFileDELETE(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file.
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {IHeaderDictionary} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadFilePOST(contentType?: string, contentDisposition?: string, headers?: IHeaderDictionary, length?: number, name?: string, fileName?: string, options?: any): AxiosPromise<string> {
            return localVarFp.fileUploadFilePOST(contentType, contentDisposition, headers, length, name, fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @summary Get the location and description of the file by id.
     * @param {string} [guid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileGetFile(guid?: string, options?: any) {
        return FileApiFp(this.configuration).fileGetFile(guid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete file. (Cancelling the upload with FilePond plugin.) Must provide the fileGuid in the body of the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileUploadFileDELETE(options?: any) {
        return FileApiFp(this.configuration).fileUploadFileDELETE(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file.
     * @param {string} [contentType] 
     * @param {string} [contentDisposition] 
     * @param {IHeaderDictionary} [headers] 
     * @param {number} [length] 
     * @param {string} [name] 
     * @param {string} [fileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileUploadFilePOST(contentType?: string, contentDisposition?: string, headers?: IHeaderDictionary, length?: number, name?: string, fileName?: string, options?: any) {
        return FileApiFp(this.configuration).fileUploadFilePOST(contentType, contentDisposition, headers, length, name, fileName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ask a question which cannot be found in the FAQ.
         * @param {AskNonFaqQuestionCommand} askNonFaqQuestionCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsAskNonFaqQuestion: async (askNonFaqQuestionCommand: AskNonFaqQuestionCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'askNonFaqQuestionCommand' is not null or undefined
            assertParamExists('formsAskNonFaqQuestion', 'askNonFaqQuestionCommand', askNonFaqQuestionCommand)
            const localVarPath = `/api/portal/Forms/AskNonFaqQuestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(askNonFaqQuestionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all dropdown data for the alkmaar form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsGetDropdownDataAlkmaar: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Forms/GetDropdownDataAlkmaar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all dropdown data for the apeldoorn form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsGetDropdownDataApeldoorn: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Forms/GetDropdownDataApeldoorn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get userdetails of user posting a form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsGetFormPostUserDetails: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Forms/GetFormPostUserDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Report an imperfection of the order. Sends email to Spits.
         * @param {ReportImperfectionCommand} reportImperfectionCommand Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfection: async (reportImperfectionCommand: ReportImperfectionCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportImperfectionCommand' is not null or undefined
            assertParamExists('formsReportImperfection', 'reportImperfectionCommand', reportImperfectionCommand)
            const localVarPath = `/api/portal/Forms/ReportImperfection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportImperfectionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Alkmaar
         * @param {ImperfectionInceptionDto2} imperfectionInceptionDto2 Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfectionInceptionAlkmaar: async (imperfectionInceptionDto2: ImperfectionInceptionDto2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'imperfectionInceptionDto2' is not null or undefined
            assertParamExists('formsReportImperfectionInceptionAlkmaar', 'imperfectionInceptionDto2', imperfectionInceptionDto2)
            const localVarPath = `/api/portal/Forms/ReportImperfectionInceptionAlkmaar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(imperfectionInceptionDto2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Apeldoorn
         * @param {ImperfectionInceptionDto} imperfectionInceptionDto Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfectionInceptionApeldoorn: async (imperfectionInceptionDto: ImperfectionInceptionDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'imperfectionInceptionDto' is not null or undefined
            assertParamExists('formsReportImperfectionInceptionApeldoorn', 'imperfectionInceptionDto', imperfectionInceptionDto)
            const localVarPath = `/api/portal/Forms/ReportImperfectionInceptionApeldoorn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(imperfectionInceptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Oosterwolde.
         * @param {ReportImperfectionInceptionCommand} reportImperfectionInceptionCommand Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfectionInceptionOosterwolde: async (reportImperfectionInceptionCommand: ReportImperfectionInceptionCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportImperfectionInceptionCommand' is not null or undefined
            assertParamExists('formsReportImperfectionInceptionOosterwolde', 'reportImperfectionInceptionCommand', reportImperfectionInceptionCommand)
            const localVarPath = `/api/portal/Forms/ReportImperfectionInceptionOosterwolde`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportImperfectionInceptionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a immediate product (emergency). Sends email to Spits.
         * @param {RequestImmediateProductCommand} requestImmediateProductCommand Request for immediate product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestImmediateProduct: async (requestImmediateProductCommand: RequestImmediateProductCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestImmediateProductCommand' is not null or undefined
            assertParamExists('formsRequestImmediateProduct', 'requestImmediateProductCommand', requestImmediateProductCommand)
            const localVarPath = `/api/portal/Forms/RequestImmediateProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestImmediateProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a new department. Sends email to Spits.
         * @param {RequestNewDepartmentCommand} requestNewDepartmentCommand Request a new department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestNewDepartment: async (requestNewDepartmentCommand: RequestNewDepartmentCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestNewDepartmentCommand' is not null or undefined
            assertParamExists('formsRequestNewDepartment', 'requestNewDepartmentCommand', requestNewDepartmentCommand)
            const localVarPath = `/api/portal/Forms/RequestNewDepartment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestNewDepartmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a new product. Sends email to Spits.
         * @param {RequestNewProductCommand} requestNewProductCommand Request for a new product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestNewProduct: async (requestNewProductCommand: RequestNewProductCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestNewProductCommand' is not null or undefined
            assertParamExists('formsRequestNewProduct', 'requestNewProductCommand', requestNewProductCommand)
            const localVarPath = `/api/portal/Forms/RequestNewProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestNewProductCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request an offline assortment. Sends email to Spits.
         * @param {RequestOfflineAssortmentCommand} requestOfflineAssortmentCommand Request for an offline assortment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestOfflineAssortment: async (requestOfflineAssortmentCommand: RequestOfflineAssortmentCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestOfflineAssortmentCommand' is not null or undefined
            assertParamExists('formsRequestOfflineAssortment', 'requestOfflineAssortmentCommand', requestOfflineAssortmentCommand)
            const localVarPath = `/api/portal/Forms/RequestOfflineAssortment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestOfflineAssortmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a photo of a medicine roll. Sends email to Spits.
         * @param {RequestPhotoCommand} requestPhotoCommand Request for a photo.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestPhoto: async (requestPhotoCommand: RequestPhotoCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPhotoCommand' is not null or undefined
            assertParamExists('formsRequestPhoto', 'requestPhotoCommand', requestPhotoCommand)
            const localVarPath = `/api/portal/Forms/RequestPhoto`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPhotoCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request to stop a department. Sends email to Spits.
         * @param {RequestStopDepartmentCommand} requestStopDepartmentCommand Request to stop a department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestStopDepartment: async (requestStopDepartmentCommand: RequestStopDepartmentCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestStopDepartmentCommand' is not null or undefined
            assertParamExists('formsRequestStopDepartment', 'requestStopDepartmentCommand', requestStopDepartmentCommand)
            const localVarPath = `/api/portal/Forms/RequestStopDepartment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestStopDepartmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ask a question which cannot be found in the FAQ.
         * @param {AskNonFaqQuestionCommand} askNonFaqQuestionCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsAskNonFaqQuestion(askNonFaqQuestionCommand: AskNonFaqQuestionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsAskNonFaqQuestion(askNonFaqQuestionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all dropdown data for the alkmaar form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsGetDropdownDataAlkmaar(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DropdownDataDto2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsGetDropdownDataAlkmaar(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all dropdown data for the apeldoorn form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsGetDropdownDataApeldoorn(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DropdownDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsGetDropdownDataApeldoorn(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get userdetails of user posting a form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsGetFormPostUserDetails(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFormPostUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsGetFormPostUserDetails(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Report an imperfection of the order. Sends email to Spits.
         * @param {ReportImperfectionCommand} reportImperfectionCommand Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsReportImperfection(reportImperfectionCommand: ReportImperfectionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsReportImperfection(reportImperfectionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Alkmaar
         * @param {ImperfectionInceptionDto2} imperfectionInceptionDto2 Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsReportImperfectionInceptionAlkmaar(imperfectionInceptionDto2: ImperfectionInceptionDto2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsReportImperfectionInceptionAlkmaar(imperfectionInceptionDto2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Apeldoorn
         * @param {ImperfectionInceptionDto} imperfectionInceptionDto Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsReportImperfectionInceptionApeldoorn(imperfectionInceptionDto: ImperfectionInceptionDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsReportImperfectionInceptionApeldoorn(imperfectionInceptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Oosterwolde.
         * @param {ReportImperfectionInceptionCommand} reportImperfectionInceptionCommand Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsReportImperfectionInceptionOosterwolde(reportImperfectionInceptionCommand: ReportImperfectionInceptionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsReportImperfectionInceptionOosterwolde(reportImperfectionInceptionCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request a immediate product (emergency). Sends email to Spits.
         * @param {RequestImmediateProductCommand} requestImmediateProductCommand Request for immediate product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsRequestImmediateProduct(requestImmediateProductCommand: RequestImmediateProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsRequestImmediateProduct(requestImmediateProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request a new department. Sends email to Spits.
         * @param {RequestNewDepartmentCommand} requestNewDepartmentCommand Request a new department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsRequestNewDepartment(requestNewDepartmentCommand: RequestNewDepartmentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsRequestNewDepartment(requestNewDepartmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request a new product. Sends email to Spits.
         * @param {RequestNewProductCommand} requestNewProductCommand Request for a new product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsRequestNewProduct(requestNewProductCommand: RequestNewProductCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsRequestNewProduct(requestNewProductCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request an offline assortment. Sends email to Spits.
         * @param {RequestOfflineAssortmentCommand} requestOfflineAssortmentCommand Request for an offline assortment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsRequestOfflineAssortment(requestOfflineAssortmentCommand: RequestOfflineAssortmentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsRequestOfflineAssortment(requestOfflineAssortmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request a photo of a medicine roll. Sends email to Spits.
         * @param {RequestPhotoCommand} requestPhotoCommand Request for a photo.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsRequestPhoto(requestPhotoCommand: RequestPhotoCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsRequestPhoto(requestPhotoCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request to stop a department. Sends email to Spits.
         * @param {RequestStopDepartmentCommand} requestStopDepartmentCommand Request to stop a department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsRequestStopDepartment(requestStopDepartmentCommand: RequestStopDepartmentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsRequestStopDepartment(requestStopDepartmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsApiFp(configuration)
    return {
        /**
         * 
         * @summary Ask a question which cannot be found in the FAQ.
         * @param {AskNonFaqQuestionCommand} askNonFaqQuestionCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsAskNonFaqQuestion(askNonFaqQuestionCommand: AskNonFaqQuestionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsAskNonFaqQuestion(askNonFaqQuestionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all dropdown data for the alkmaar form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsGetDropdownDataAlkmaar(options?: any): AxiosPromise<DropdownDataDto2> {
            return localVarFp.formsGetDropdownDataAlkmaar(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all dropdown data for the apeldoorn form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsGetDropdownDataApeldoorn(options?: any): AxiosPromise<DropdownDataDto> {
            return localVarFp.formsGetDropdownDataApeldoorn(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get userdetails of user posting a form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsGetFormPostUserDetails(options?: any): AxiosPromise<GetFormPostUserDetailsDto> {
            return localVarFp.formsGetFormPostUserDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Report an imperfection of the order. Sends email to Spits.
         * @param {ReportImperfectionCommand} reportImperfectionCommand Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfection(reportImperfectionCommand: ReportImperfectionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsReportImperfection(reportImperfectionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Alkmaar
         * @param {ImperfectionInceptionDto2} imperfectionInceptionDto2 Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfectionInceptionAlkmaar(imperfectionInceptionDto2: ImperfectionInceptionDto2, options?: any): AxiosPromise<void> {
            return localVarFp.formsReportImperfectionInceptionAlkmaar(imperfectionInceptionDto2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Apeldoorn
         * @param {ImperfectionInceptionDto} imperfectionInceptionDto Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfectionInceptionApeldoorn(imperfectionInceptionDto: ImperfectionInceptionDto, options?: any): AxiosPromise<void> {
            return localVarFp.formsReportImperfectionInceptionApeldoorn(imperfectionInceptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Report an imperfection of the order to inception for Oosterwolde.
         * @param {ReportImperfectionInceptionCommand} reportImperfectionInceptionCommand Request for a imperfection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsReportImperfectionInceptionOosterwolde(reportImperfectionInceptionCommand: ReportImperfectionInceptionCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsReportImperfectionInceptionOosterwolde(reportImperfectionInceptionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a immediate product (emergency). Sends email to Spits.
         * @param {RequestImmediateProductCommand} requestImmediateProductCommand Request for immediate product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestImmediateProduct(requestImmediateProductCommand: RequestImmediateProductCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsRequestImmediateProduct(requestImmediateProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a new department. Sends email to Spits.
         * @param {RequestNewDepartmentCommand} requestNewDepartmentCommand Request a new department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestNewDepartment(requestNewDepartmentCommand: RequestNewDepartmentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsRequestNewDepartment(requestNewDepartmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a new product. Sends email to Spits.
         * @param {RequestNewProductCommand} requestNewProductCommand Request for a new product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestNewProduct(requestNewProductCommand: RequestNewProductCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsRequestNewProduct(requestNewProductCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request an offline assortment. Sends email to Spits.
         * @param {RequestOfflineAssortmentCommand} requestOfflineAssortmentCommand Request for an offline assortment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestOfflineAssortment(requestOfflineAssortmentCommand: RequestOfflineAssortmentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsRequestOfflineAssortment(requestOfflineAssortmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a photo of a medicine roll. Sends email to Spits.
         * @param {RequestPhotoCommand} requestPhotoCommand Request for a photo.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestPhoto(requestPhotoCommand: RequestPhotoCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsRequestPhoto(requestPhotoCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request to stop a department. Sends email to Spits.
         * @param {RequestStopDepartmentCommand} requestStopDepartmentCommand Request to stop a department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsRequestStopDepartment(requestStopDepartmentCommand: RequestStopDepartmentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.formsRequestStopDepartment(requestStopDepartmentCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
    /**
     * 
     * @summary Ask a question which cannot be found in the FAQ.
     * @param {AskNonFaqQuestionCommand} askNonFaqQuestionCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsAskNonFaqQuestion(askNonFaqQuestionCommand: AskNonFaqQuestionCommand, options?: any) {
        return FormsApiFp(this.configuration).formsAskNonFaqQuestion(askNonFaqQuestionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all dropdown data for the alkmaar form.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsGetDropdownDataAlkmaar(options?: any) {
        return FormsApiFp(this.configuration).formsGetDropdownDataAlkmaar(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all dropdown data for the apeldoorn form.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsGetDropdownDataApeldoorn(options?: any) {
        return FormsApiFp(this.configuration).formsGetDropdownDataApeldoorn(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get userdetails of user posting a form
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsGetFormPostUserDetails(options?: any) {
        return FormsApiFp(this.configuration).formsGetFormPostUserDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Report an imperfection of the order. Sends email to Spits.
     * @param {ReportImperfectionCommand} reportImperfectionCommand Request for a imperfection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsReportImperfection(reportImperfectionCommand: ReportImperfectionCommand, options?: any) {
        return FormsApiFp(this.configuration).formsReportImperfection(reportImperfectionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Report an imperfection of the order to inception for Alkmaar
     * @param {ImperfectionInceptionDto2} imperfectionInceptionDto2 Request for a imperfection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsReportImperfectionInceptionAlkmaar(imperfectionInceptionDto2: ImperfectionInceptionDto2, options?: any) {
        return FormsApiFp(this.configuration).formsReportImperfectionInceptionAlkmaar(imperfectionInceptionDto2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Report an imperfection of the order to inception for Apeldoorn
     * @param {ImperfectionInceptionDto} imperfectionInceptionDto Request for a imperfection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsReportImperfectionInceptionApeldoorn(imperfectionInceptionDto: ImperfectionInceptionDto, options?: any) {
        return FormsApiFp(this.configuration).formsReportImperfectionInceptionApeldoorn(imperfectionInceptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Report an imperfection of the order to inception for Oosterwolde.
     * @param {ReportImperfectionInceptionCommand} reportImperfectionInceptionCommand Request for a imperfection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsReportImperfectionInceptionOosterwolde(reportImperfectionInceptionCommand: ReportImperfectionInceptionCommand, options?: any) {
        return FormsApiFp(this.configuration).formsReportImperfectionInceptionOosterwolde(reportImperfectionInceptionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a immediate product (emergency). Sends email to Spits.
     * @param {RequestImmediateProductCommand} requestImmediateProductCommand Request for immediate product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsRequestImmediateProduct(requestImmediateProductCommand: RequestImmediateProductCommand, options?: any) {
        return FormsApiFp(this.configuration).formsRequestImmediateProduct(requestImmediateProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a new department. Sends email to Spits.
     * @param {RequestNewDepartmentCommand} requestNewDepartmentCommand Request a new department.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsRequestNewDepartment(requestNewDepartmentCommand: RequestNewDepartmentCommand, options?: any) {
        return FormsApiFp(this.configuration).formsRequestNewDepartment(requestNewDepartmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a new product. Sends email to Spits.
     * @param {RequestNewProductCommand} requestNewProductCommand Request for a new product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsRequestNewProduct(requestNewProductCommand: RequestNewProductCommand, options?: any) {
        return FormsApiFp(this.configuration).formsRequestNewProduct(requestNewProductCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request an offline assortment. Sends email to Spits.
     * @param {RequestOfflineAssortmentCommand} requestOfflineAssortmentCommand Request for an offline assortment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsRequestOfflineAssortment(requestOfflineAssortmentCommand: RequestOfflineAssortmentCommand, options?: any) {
        return FormsApiFp(this.configuration).formsRequestOfflineAssortment(requestOfflineAssortmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a photo of a medicine roll. Sends email to Spits.
     * @param {RequestPhotoCommand} requestPhotoCommand Request for a photo.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsRequestPhoto(requestPhotoCommand: RequestPhotoCommand, options?: any) {
        return FormsApiFp(this.configuration).formsRequestPhoto(requestPhotoCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request to stop a department. Sends email to Spits.
     * @param {RequestStopDepartmentCommand} requestStopDepartmentCommand Request to stop a department.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public formsRequestStopDepartment(requestStopDepartmentCommand: RequestStopDepartmentCommand, options?: any) {
        return FormsApiFp(this.configuration).formsRequestStopDepartment(requestStopDepartmentCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InvoiceApi - axios parameter creator
 * @export
 */
export const InvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download the invoice for a specific user.
         * @param {string} [processedMonth] Processed month (format: \&quot;YYYYMM\&quot;).
         * @param {string} [clientCode] Client code.
         * @param {InvoiceFileType} [fileType] File type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceDownloadInvoiceFile: async (processedMonth?: string, clientCode?: string, fileType?: InvoiceFileType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Invoice/DownloadInvoiceFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (processedMonth !== undefined) {
                localVarQueryParameter['ProcessedMonth'] = processedMonth;
            }

            if (clientCode !== undefined) {
                localVarQueryParameter['ClientCode'] = clientCode;
            }

            if (fileType !== undefined) {
                localVarQueryParameter['FileType'] = fileType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all invoice by client code as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceGetInvoiceTable: async (vueTableRequest: VueTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vueTableRequest' is not null or undefined
            assertParamExists('invoiceGetInvoiceTable', 'vueTableRequest', vueTableRequest)
            const localVarPath = `/api/portal/Invoice/GetInvoiceTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vueTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceApi - functional programming interface
 * @export
 */
export const InvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download the invoice for a specific user.
         * @param {string} [processedMonth] Processed month (format: \&quot;YYYYMM\&quot;).
         * @param {string} [clientCode] Client code.
         * @param {InvoiceFileType} [fileType] File type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceDownloadInvoiceFile(processedMonth?: string, clientCode?: string, fileType?: InvoiceFileType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceDownloadInvoiceFile(processedMonth, clientCode, fileType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of all invoice by client code as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceGetInvoiceTable(vueTableRequest: VueTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VueTableResponseOfInvoiceTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceGetInvoiceTable(vueTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvoiceApi - factory interface
 * @export
 */
export const InvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Download the invoice for a specific user.
         * @param {string} [processedMonth] Processed month (format: \&quot;YYYYMM\&quot;).
         * @param {string} [clientCode] Client code.
         * @param {InvoiceFileType} [fileType] File type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceDownloadInvoiceFile(processedMonth?: string, clientCode?: string, fileType?: InvoiceFileType, options?: any): AxiosPromise<any> {
            return localVarFp.invoiceDownloadInvoiceFile(processedMonth, clientCode, fileType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all invoice by client code as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceGetInvoiceTable(vueTableRequest: VueTableRequest, options?: any): AxiosPromise<VueTableResponseOfInvoiceTableDto> {
            return localVarFp.invoiceGetInvoiceTable(vueTableRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceApi - object-oriented interface
 * @export
 * @class InvoiceApi
 * @extends {BaseAPI}
 */
export class InvoiceApi extends BaseAPI {
    /**
     * 
     * @summary Download the invoice for a specific user.
     * @param {string} [processedMonth] Processed month (format: \&quot;YYYYMM\&quot;).
     * @param {string} [clientCode] Client code.
     * @param {InvoiceFileType} [fileType] File type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public invoiceDownloadInvoiceFile(processedMonth?: string, clientCode?: string, fileType?: InvoiceFileType, options?: any) {
        return InvoiceApiFp(this.configuration).invoiceDownloadInvoiceFile(processedMonth, clientCode, fileType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all invoice by client code as a VueTableResponse.
     * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public invoiceGetInvoiceTable(vueTableRequest: VueTableRequest, options?: any) {
        return InvoiceApiFp(this.configuration).invoiceGetInvoiceTable(vueTableRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get content.
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaGetContent: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Media/GetContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get content.
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mediaGetContent(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mediaGetContent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * 
         * @summary Get content.
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mediaGetContent(id?: string, options?: any): AxiosPromise<void> {
            return localVarFp.mediaGetContent(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
    /**
     * 
     * @summary Get content.
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public mediaGetContent(id?: string, options?: any) {
        return MediaApiFp(this.configuration).mediaGetContent(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MemoApi - axios parameter creator
 * @export
 */
export const MemoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of all active memos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoGetActiveMemos: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Memo/GetActiveMemos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemoApi - functional programming interface
 * @export
 */
export const MemoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a list of all active memos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoGetActiveMemos(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoGetActiveMemos(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MemoApi - factory interface
 * @export
 */
export const MemoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemoApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a list of all active memos.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoGetActiveMemos(options?: any): AxiosPromise<Array<MemoDto>> {
            return localVarFp.memoGetActiveMemos(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MemoApi - object-oriented interface
 * @export
 * @class MemoApi
 * @extends {BaseAPI}
 */
export class MemoApi extends BaseAPI {
    /**
     * 
     * @summary Get a list of all active memos.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoApi
     */
    public memoGetActiveMemos(options?: any) {
        return MemoApiFp(this.configuration).memoGetActiveMemos(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets orderfulfillment schedule by pharmacy client
         * @param {VueTableRequest} vueTableRequest Vue data table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderFulfillmentSchedulesTable: async (vueTableRequest: VueTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vueTableRequest' is not null or undefined
            assertParamExists('orderGetOrderFulfillmentSchedulesTable', 'vueTableRequest', vueTableRequest)
            const localVarPath = `/api/portal/Order/GetOrderFulfillmentSchedulesTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vueTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all fulfilled orders
         * @param {VueTableRequest} vueTableRequest Vue data table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderFulfillmentsTable: async (vueTableRequest: VueTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vueTableRequest' is not null or undefined
            assertParamExists('orderGetOrderFulfillmentsTable', 'vueTableRequest', vueTableRequest)
            const localVarPath = `/api/portal/Order/GetOrderFulfillmentsTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vueTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets orderfulfillment schedule by pharmacy client
         * @param {VueTableRequest} vueTableRequest Vue data table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderGetOrderFulfillmentSchedulesTable(vueTableRequest: VueTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VueTableResponseOfOrderFulfillmentScheduleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderGetOrderFulfillmentSchedulesTable(vueTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all fulfilled orders
         * @param {VueTableRequest} vueTableRequest Vue data table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderGetOrderFulfillmentsTable(vueTableRequest: VueTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VueTableResponseOfOrderFulfillmentTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderGetOrderFulfillmentsTable(vueTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets orderfulfillment schedule by pharmacy client
         * @param {VueTableRequest} vueTableRequest Vue data table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderFulfillmentSchedulesTable(vueTableRequest: VueTableRequest, options?: any): AxiosPromise<VueTableResponseOfOrderFulfillmentScheduleDto> {
            return localVarFp.orderGetOrderFulfillmentSchedulesTable(vueTableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all fulfilled orders
         * @param {VueTableRequest} vueTableRequest Vue data table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderFulfillmentsTable(vueTableRequest: VueTableRequest, options?: any): AxiosPromise<VueTableResponseOfOrderFulfillmentTableDto> {
            return localVarFp.orderGetOrderFulfillmentsTable(vueTableRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @summary Gets orderfulfillment schedule by pharmacy client
     * @param {VueTableRequest} vueTableRequest Vue data table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderGetOrderFulfillmentSchedulesTable(vueTableRequest: VueTableRequest, options?: any) {
        return OrderApiFp(this.configuration).orderGetOrderFulfillmentSchedulesTable(vueTableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all fulfilled orders
     * @param {VueTableRequest} vueTableRequest Vue data table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderGetOrderFulfillmentsTable(vueTableRequest: VueTableRequest, options?: any) {
        return OrderApiFp(this.configuration).orderGetOrderFulfillmentsTable(vueTableRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PatientApi - axios parameter creator
 * @export
 */
export const PatientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the patients for logged in pharmacist.
         * @param {SearchPatientQuery} searchPatientQuery Query providing filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSearchPatients: async (searchPatientQuery: SearchPatientQuery, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPatientQuery' is not null or undefined
            assertParamExists('patientSearchPatients', 'searchPatientQuery', searchPatientQuery)
            const localVarPath = `/api/portal/Patient/SearchPatients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPatientQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientApi - functional programming interface
 * @export
 */
export const PatientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the patients for logged in pharmacist.
         * @param {SearchPatientQuery} searchPatientQuery Query providing filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientSearchPatients(searchPatientQuery: SearchPatientQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientSearchPatients(searchPatientQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PatientApi - factory interface
 * @export
 */
export const PatientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the patients for logged in pharmacist.
         * @param {SearchPatientQuery} searchPatientQuery Query providing filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSearchPatients(searchPatientQuery: SearchPatientQuery, options?: any): AxiosPromise<Array<PatientDto>> {
            return localVarFp.patientSearchPatients(searchPatientQuery, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientApi - object-oriented interface
 * @export
 * @class PatientApi
 * @extends {BaseAPI}
 */
export class PatientApi extends BaseAPI {
    /**
     * 
     * @summary Get the patients for logged in pharmacist.
     * @param {SearchPatientQuery} searchPatientQuery Query providing filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientApi
     */
    public patientSearchPatients(searchPatientQuery: SearchPatientQuery, options?: any) {
        return PatientApiFp(this.configuration).patientSearchPatients(searchPatientQuery, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PharmacistApi - axios parameter creator
 * @export
 */
export const PharmacistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new pharmacist.
         * @param {AddPharmacistRequest} addPharmacistRequest Request providing the new pharmacist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistAddPharmacist: async (addPharmacistRequest: AddPharmacistRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addPharmacistRequest' is not null or undefined
            assertParamExists('pharmacistAddPharmacist', 'addPharmacistRequest', addPharmacistRequest)
            const localVarPath = `/api/portal/Pharmacist/AddPharmacist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPharmacistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the pharmacist indicated.
         * @param {number} [id] Request indicating the pharmacist to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistDeletePharmacistById: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Pharmacist/DeletePharmacistById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a pharmacist.
         * @param {number} [accountId] Account id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistGetPharmacistById: async (accountId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/Pharmacist/GetPharmacistById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (accountId !== undefined) {
                localVarQueryParameter['AccountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all pharmacists as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistGetPharmacistTable: async (vueTableRequest: VueTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vueTableRequest' is not null or undefined
            assertParamExists('pharmacistGetPharmacistTable', 'vueTableRequest', vueTableRequest)
            const localVarPath = `/api/portal/Pharmacist/GetPharmacistTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vueTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the pharmacist.
         * @param {UpdatePharmacistRequest} updatePharmacistRequest Request providing the new pharmacist details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistUpdatePharmacist: async (updatePharmacistRequest: UpdatePharmacistRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePharmacistRequest' is not null or undefined
            assertParamExists('pharmacistUpdatePharmacist', 'updatePharmacistRequest', updatePharmacistRequest)
            const localVarPath = `/api/portal/Pharmacist/UpdatePharmacist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePharmacistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PharmacistApi - functional programming interface
 * @export
 */
export const PharmacistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PharmacistApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new pharmacist.
         * @param {AddPharmacistRequest} addPharmacistRequest Request providing the new pharmacist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pharmacistAddPharmacist(addPharmacistRequest: AddPharmacistRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pharmacistAddPharmacist(addPharmacistRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete the pharmacist indicated.
         * @param {number} [id] Request indicating the pharmacist to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pharmacistDeletePharmacistById(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pharmacistDeletePharmacistById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a pharmacist.
         * @param {number} [accountId] Account id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pharmacistGetPharmacistById(accountId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PharmacistDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pharmacistGetPharmacistById(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of all pharmacists as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pharmacistGetPharmacistTable(vueTableRequest: VueTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VueTableResponseOfPharmacistTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pharmacistGetPharmacistTable(vueTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the pharmacist.
         * @param {UpdatePharmacistRequest} updatePharmacistRequest Request providing the new pharmacist details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pharmacistUpdatePharmacist(updatePharmacistRequest: UpdatePharmacistRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pharmacistUpdatePharmacist(updatePharmacistRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PharmacistApi - factory interface
 * @export
 */
export const PharmacistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PharmacistApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new pharmacist.
         * @param {AddPharmacistRequest} addPharmacistRequest Request providing the new pharmacist.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistAddPharmacist(addPharmacistRequest: AddPharmacistRequest, options?: any): AxiosPromise<number> {
            return localVarFp.pharmacistAddPharmacist(addPharmacistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the pharmacist indicated.
         * @param {number} [id] Request indicating the pharmacist to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistDeletePharmacistById(id?: number, options?: any): AxiosPromise<void> {
            return localVarFp.pharmacistDeletePharmacistById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a pharmacist.
         * @param {number} [accountId] Account id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistGetPharmacistById(accountId?: number, options?: any): AxiosPromise<PharmacistDto> {
            return localVarFp.pharmacistGetPharmacistById(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all pharmacists as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistGetPharmacistTable(vueTableRequest: VueTableRequest, options?: any): AxiosPromise<VueTableResponseOfPharmacistTableDto> {
            return localVarFp.pharmacistGetPharmacistTable(vueTableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the pharmacist.
         * @param {UpdatePharmacistRequest} updatePharmacistRequest Request providing the new pharmacist details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pharmacistUpdatePharmacist(updatePharmacistRequest: UpdatePharmacistRequest, options?: any): AxiosPromise<void> {
            return localVarFp.pharmacistUpdatePharmacist(updatePharmacistRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PharmacistApi - object-oriented interface
 * @export
 * @class PharmacistApi
 * @extends {BaseAPI}
 */
export class PharmacistApi extends BaseAPI {
    /**
     * 
     * @summary Add a new pharmacist.
     * @param {AddPharmacistRequest} addPharmacistRequest Request providing the new pharmacist.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacistApi
     */
    public pharmacistAddPharmacist(addPharmacistRequest: AddPharmacistRequest, options?: any) {
        return PharmacistApiFp(this.configuration).pharmacistAddPharmacist(addPharmacistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the pharmacist indicated.
     * @param {number} [id] Request indicating the pharmacist to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacistApi
     */
    public pharmacistDeletePharmacistById(id?: number, options?: any) {
        return PharmacistApiFp(this.configuration).pharmacistDeletePharmacistById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a pharmacist.
     * @param {number} [accountId] Account id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacistApi
     */
    public pharmacistGetPharmacistById(accountId?: number, options?: any) {
        return PharmacistApiFp(this.configuration).pharmacistGetPharmacistById(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all pharmacists as a VueTableResponse.
     * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacistApi
     */
    public pharmacistGetPharmacistTable(vueTableRequest: VueTableRequest, options?: any) {
        return PharmacistApiFp(this.configuration).pharmacistGetPharmacistTable(vueTableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the pharmacist.
     * @param {UpdatePharmacistRequest} updatePharmacistRequest Request providing the new pharmacist details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacistApi
     */
    public pharmacistUpdatePharmacist(updatePharmacistRequest: UpdatePharmacistRequest, options?: any) {
        return PharmacistApiFp(this.configuration).pharmacistUpdatePharmacist(updatePharmacistRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceProductApi - axios parameter creator
 * @export
 */
export const ServiceProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of all service products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductGetServiceProducts: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/ServiceProduct/GetServiceProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceProductApi - functional programming interface
 * @export
 */
export const ServiceProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a list of all service products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceProductGetServiceProducts(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProductGetServiceProducts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceProductApi - factory interface
 * @export
 */
export const ServiceProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceProductApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a list of all service products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductGetServiceProducts(options?: any): AxiosPromise<Array<ServiceProductDto>> {
            return localVarFp.serviceProductGetServiceProducts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceProductApi - object-oriented interface
 * @export
 * @class ServiceProductApi
 * @extends {BaseAPI}
 */
export class ServiceProductApi extends BaseAPI {
    /**
     * 
     * @summary Get a list of all service products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProductApi
     */
    public serviceProductGetServiceProducts(options?: any) {
        return ServiceProductApiFp(this.configuration).serviceProductGetServiceProducts(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceProductOrderApi - axios parameter creator
 * @export
 */
export const ServiceProductOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new service product order.
         * @param {AddServiceProductOrderRequest} addServiceProductOrderRequest Request providing the new service product order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductOrderAddServiceProductOrder: async (addServiceProductOrderRequest: AddServiceProductOrderRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addServiceProductOrderRequest' is not null or undefined
            assertParamExists('serviceProductOrderAddServiceProductOrder', 'addServiceProductOrderRequest', addServiceProductOrderRequest)
            const localVarPath = `/api/portal/ServiceProductOrder/AddServiceProductOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addServiceProductOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a service product order.
         * @param {number} [serviceProductOrderId] The Id of the service product order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductOrderGetServiceProductOrderById: async (serviceProductOrderId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/portal/ServiceProductOrder/GetServiceProductOrderById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (serviceProductOrderId !== undefined) {
                localVarQueryParameter['ServiceProductOrderId'] = serviceProductOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all service product orders as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductOrderGetServiceProductOrderTable: async (vueTableRequest: VueTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vueTableRequest' is not null or undefined
            assertParamExists('serviceProductOrderGetServiceProductOrderTable', 'vueTableRequest', vueTableRequest)
            const localVarPath = `/api/portal/ServiceProductOrder/GetServiceProductOrderTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vueTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceProductOrderApi - functional programming interface
 * @export
 */
export const ServiceProductOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceProductOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new service product order.
         * @param {AddServiceProductOrderRequest} addServiceProductOrderRequest Request providing the new service product order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceProductOrderAddServiceProductOrder(addServiceProductOrderRequest: AddServiceProductOrderRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProductOrderAddServiceProductOrder(addServiceProductOrderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a service product order.
         * @param {number} [serviceProductOrderId] The Id of the service product order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceProductOrderGetServiceProductOrderById(serviceProductOrderId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceProductOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProductOrderGetServiceProductOrderById(serviceProductOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of all service product orders as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceProductOrderGetServiceProductOrderTable(vueTableRequest: VueTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VueTableResponseOfServiceProductOrderTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceProductOrderGetServiceProductOrderTable(vueTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceProductOrderApi - factory interface
 * @export
 */
export const ServiceProductOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceProductOrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new service product order.
         * @param {AddServiceProductOrderRequest} addServiceProductOrderRequest Request providing the new service product order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductOrderAddServiceProductOrder(addServiceProductOrderRequest: AddServiceProductOrderRequest, options?: any): AxiosPromise<number> {
            return localVarFp.serviceProductOrderAddServiceProductOrder(addServiceProductOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a service product order.
         * @param {number} [serviceProductOrderId] The Id of the service product order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductOrderGetServiceProductOrderById(serviceProductOrderId?: number, options?: any): AxiosPromise<ServiceProductOrderDto> {
            return localVarFp.serviceProductOrderGetServiceProductOrderById(serviceProductOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all service product orders as a VueTableResponse.
         * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProductOrderGetServiceProductOrderTable(vueTableRequest: VueTableRequest, options?: any): AxiosPromise<VueTableResponseOfServiceProductOrderTableDto> {
            return localVarFp.serviceProductOrderGetServiceProductOrderTable(vueTableRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceProductOrderApi - object-oriented interface
 * @export
 * @class ServiceProductOrderApi
 * @extends {BaseAPI}
 */
export class ServiceProductOrderApi extends BaseAPI {
    /**
     * 
     * @summary Add a new service product order.
     * @param {AddServiceProductOrderRequest} addServiceProductOrderRequest Request providing the new service product order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProductOrderApi
     */
    public serviceProductOrderAddServiceProductOrder(addServiceProductOrderRequest: AddServiceProductOrderRequest, options?: any) {
        return ServiceProductOrderApiFp(this.configuration).serviceProductOrderAddServiceProductOrder(addServiceProductOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a service product order.
     * @param {number} [serviceProductOrderId] The Id of the service product order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProductOrderApi
     */
    public serviceProductOrderGetServiceProductOrderById(serviceProductOrderId?: number, options?: any) {
        return ServiceProductOrderApiFp(this.configuration).serviceProductOrderGetServiceProductOrderById(serviceProductOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all service product orders as a VueTableResponse.
     * @param {VueTableRequest} vueTableRequest Request for a Vue data table.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProductOrderApi
     */
    public serviceProductOrderGetServiceProductOrderTable(vueTableRequest: VueTableRequest, options?: any) {
        return ServiceProductOrderApiFp(this.configuration).serviceProductOrderGetServiceProductOrderTable(vueTableRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


